// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file gitpod/v1/environment.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import { file_gitpod_tools_v1_logfields } from "../tools/v1/logfields_pb";
import { file_gitpod_tools_v1_stainless } from "../tools/v1/stainless_pb";
import type { CountRequest, CountResponse } from "./count_pb";
import { file_gitpod_v1_count } from "./count_pb";
import type { AutomationTrigger } from "./environment_automation_pb";
import { file_gitpod_v1_environment_automation } from "./environment_automation_pb";
import type { Subject } from "./identity_pb";
import { file_gitpod_v1_identity } from "./identity_pb";
import type { PaginationRequest, PaginationResponse } from "./pagination_pb";
import { file_gitpod_v1_pagination } from "./pagination_pb";
import type { ListEnvironmentClassesRequestSchema, ListEnvironmentClassesResponseSchema, RunnerKind } from "./runner_configuration_pb";
import { file_gitpod_v1_runner_configuration } from "./runner_configuration_pb";
import { file_gnostic_openapi_v3_annotations } from "../../gnostic/openapi/v3/annotations_pb";
import type { Duration, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_duration, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file gitpod/v1/environment.proto.
 */
export const file_gitpod_v1_environment: GenFile = /*@__PURE__*/
  fileDesc("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", [file_buf_validate_validate, file_gitpod_tools_v1_logfields, file_gitpod_tools_v1_stainless, file_gitpod_v1_count, file_gitpod_v1_environment_automation, file_gitpod_v1_identity, file_gitpod_v1_pagination, file_gitpod_v1_runner_configuration, file_gnostic_openapi_v3_annotations, file_google_protobuf_duration, file_google_protobuf_timestamp]);

/**
 * @generated from message gitpod.v1.MarkEnvironmentActiveRequest
 */
export type MarkEnvironmentActiveRequest = Message<"gitpod.v1.MarkEnvironmentActiveRequest"> & {
  /**
   * The ID of the environment to update activity for.
   *
   * @generated from field: string environment_id = 1;
   */
  environmentId: string;

  /**
   * activity_signal specifies the activity.
   *
   * @generated from field: gitpod.v1.EnvironmentActivitySignal activity_signal = 2;
   */
  activitySignal?: EnvironmentActivitySignal;
};

/**
 * Describes the message gitpod.v1.MarkEnvironmentActiveRequest.
 * Use `create(MarkEnvironmentActiveRequestSchema)` to create a new message.
 */
export const MarkEnvironmentActiveRequestSchema: GenMessage<MarkEnvironmentActiveRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 0);

/**
 * EnvironmentActivitySignal used to signal activity for an environment.
 *
 * @generated from message gitpod.v1.EnvironmentActivitySignal
 */
export type EnvironmentActivitySignal = Message<"gitpod.v1.EnvironmentActivitySignal"> & {
  /**
   * source of the activity signal, such as "VS Code", "SSH", or "Automations".
   * It should be a human-readable string that describes the source of the activity signal.
   *
   * @generated from field: string source = 1;
   */
  source: string;

  /**
   * timestamp of when the activity was observed by the source.
   * Only reported every 5 minutes.
   * Zero value means no activity was observed.
   *
   * @generated from field: google.protobuf.Timestamp timestamp = 2;
   */
  timestamp?: Timestamp;
};

/**
 * Describes the message gitpod.v1.EnvironmentActivitySignal.
 * Use `create(EnvironmentActivitySignalSchema)` to create a new message.
 */
export const EnvironmentActivitySignalSchema: GenMessage<EnvironmentActivitySignal> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 1);

/**
 * @generated from message gitpod.v1.MarkEnvironmentActiveResponse
 */
export type MarkEnvironmentActiveResponse = Message<"gitpod.v1.MarkEnvironmentActiveResponse"> & {
};

/**
 * Describes the message gitpod.v1.MarkEnvironmentActiveResponse.
 * Use `create(MarkEnvironmentActiveResponseSchema)` to create a new message.
 */
export const MarkEnvironmentActiveResponseSchema: GenMessage<MarkEnvironmentActiveResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 2);

/**
 * @generated from message gitpod.v1.GetEnvironmentRequest
 */
export type GetEnvironmentRequest = Message<"gitpod.v1.GetEnvironmentRequest"> & {
  /**
   * environment_id specifies the environment to get
   *
   * @generated from field: string environment_id = 1;
   */
  environmentId: string;
};

/**
 * Describes the message gitpod.v1.GetEnvironmentRequest.
 * Use `create(GetEnvironmentRequestSchema)` to create a new message.
 */
export const GetEnvironmentRequestSchema: GenMessage<GetEnvironmentRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 3);

/**
 * @generated from message gitpod.v1.GetEnvironmentResponse
 */
export type GetEnvironmentResponse = Message<"gitpod.v1.GetEnvironmentResponse"> & {
  /**
   * @generated from field: gitpod.v1.Environment environment = 1;
   */
  environment?: Environment;
};

/**
 * Describes the message gitpod.v1.GetEnvironmentResponse.
 * Use `create(GetEnvironmentResponseSchema)` to create a new message.
 */
export const GetEnvironmentResponseSchema: GenMessage<GetEnvironmentResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 4);

/**
 * @generated from message gitpod.v1.ListEnvironmentsRequest
 */
export type ListEnvironmentsRequest = Message<"gitpod.v1.ListEnvironmentsRequest"> & {
  /**
   * pagination contains the pagination options for listing environments
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * @generated from field: gitpod.v1.ListEnvironmentsRequest.Filter filter = 3;
   */
  filter?: ListEnvironmentsRequest_Filter;

  /**
   * count controls whether the response includes a bounded total count.
   *
   * @generated from field: gitpod.v1.CountRequest count = 4;
   */
  count?: CountRequest;
};

/**
 * Describes the message gitpod.v1.ListEnvironmentsRequest.
 * Use `create(ListEnvironmentsRequestSchema)` to create a new message.
 */
export const ListEnvironmentsRequestSchema: GenMessage<ListEnvironmentsRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 5);

/**
 * @generated from message gitpod.v1.ListEnvironmentsRequest.Filter
 */
export type ListEnvironmentsRequest_Filter = Message<"gitpod.v1.ListEnvironmentsRequest.Filter"> & {
  /**
   * runner_ids filters the response to only Environments running on these Runner IDs
   *
   * @generated from field: repeated string runner_ids = 1;
   */
  runnerIds: string[];

  /**
   * actual_phases is a list of phases the environment must be in for it to be returned in the API call
   *
   * @generated from field: repeated gitpod.v1.EnvironmentPhase status_phases = 2;
   */
  statusPhases: EnvironmentPhase[];

  /**
   * creator_ids filters the response to only Environments created by specified members
   *
   * @generated from field: repeated string creator_ids = 3;
   */
  creatorIds: string[];

  /**
   * project_ids filters the response to only Environments associated with the specified projects
   *
   * @generated from field: repeated string project_ids = 4;
   */
  projectIds: string[];

  /**
   * runner_kinds filters the response to only Environments running on these Runner Kinds
   *
   * @generated from field: repeated gitpod.v1.RunnerKind runner_kinds = 5;
   */
  runnerKinds: RunnerKind[];

  /**
   * archival_status filters the response based on environment archive status
   *
   * @generated from field: optional gitpod.v1.ListEnvironmentsRequest.ArchivalStatus archival_status = 6;
   */
  archivalStatus?: ListEnvironmentsRequest_ArchivalStatus;

  /**
   * created_before filters environments created before this timestamp
   *
   * @generated from field: optional google.protobuf.Timestamp created_before = 7;
   */
  createdBefore?: Timestamp;

  /**
   * roles filters the response to only Environments with the specified roles
   *
   * @generated from field: repeated gitpod.v1.EnvironmentRole roles = 8;
   */
  roles: EnvironmentRole[];

  /**
   * lockdown_before filters environments whose lockdown_at is before this timestamp.
   * Only environments with lockdown_at set are matched.
   *
   * @generated from field: optional google.protobuf.Timestamp lockdown_before = 10;
   */
  lockdownBefore?: Timestamp;

  /**
   * search performs case-insensitive search across environment ID, name, repository URL, and branch
   *
   * @generated from field: string search = 11;
   */
  search: string;

  /**
   * session_ids filters the response to only environments belonging to the specified sessions
   *
   * @generated from field: repeated string session_ids = 12;
   */
  sessionIds: string[];
};

/**
 * Describes the message gitpod.v1.ListEnvironmentsRequest.Filter.
 * Use `create(ListEnvironmentsRequest_FilterSchema)` to create a new message.
 */
export const ListEnvironmentsRequest_FilterSchema: GenMessage<ListEnvironmentsRequest_Filter> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 5, 0);

/**
 * @generated from enum gitpod.v1.ListEnvironmentsRequest.ArchivalStatus
 */
export enum ListEnvironmentsRequest_ArchivalStatus {
  /**
   * @generated from enum value: ARCHIVAL_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ARCHIVAL_STATUS_ACTIVE = 1;
   */
  ACTIVE = 1,

  /**
   * @generated from enum value: ARCHIVAL_STATUS_ARCHIVED = 2;
   */
  ARCHIVED = 2,

  /**
   * @generated from enum value: ARCHIVAL_STATUS_ALL = 3;
   */
  ALL = 3,
}

/**
 * Describes the enum gitpod.v1.ListEnvironmentsRequest.ArchivalStatus.
 */
export const ListEnvironmentsRequest_ArchivalStatusSchema: GenEnum<ListEnvironmentsRequest_ArchivalStatus> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_environment, 5, 0);

/**
 * @generated from message gitpod.v1.ListEnvironmentsResponse
 */
export type ListEnvironmentsResponse = Message<"gitpod.v1.ListEnvironmentsResponse"> & {
  /**
   * pagination contains the pagination options for listing environments
   *
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * environments are the environments that matched the query
   *
   * @generated from field: repeated gitpod.v1.Environment environments = 2;
   */
  environments: Environment[];

  /**
   * count is the bounded total count of matching environments, present only
   * when requested via CountRequest.include on the first page.
   *
   * @generated from field: gitpod.v1.CountResponse count = 3;
   */
  count?: CountResponse;
};

/**
 * Describes the message gitpod.v1.ListEnvironmentsResponse.
 * Use `create(ListEnvironmentsResponseSchema)` to create a new message.
 */
export const ListEnvironmentsResponseSchema: GenMessage<ListEnvironmentsResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 6);

/**
 * Required fields:
 * - metadata.organization_id
 * - metadata.configuration_id
 *
 * @generated from message gitpod.v1.CreateEnvironmentRequest
 */
export type CreateEnvironmentRequest = Message<"gitpod.v1.CreateEnvironmentRequest"> & {
  /**
   * spec is the configuration of the environment that's required for the to
   * start the environment
   *
   * @generated from field: gitpod.v1.EnvironmentSpec spec = 1;
   */
  spec?: EnvironmentSpec;

  /**
   * name is a user-defined identifier for the environment.
   * If not specified, the system will generate a name.
   *
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * session_id is the ID of the session this environment belongs to.
   * If empty, a new session is created implicitly.
   *
   * @generated from field: string session_id = 3;
   */
  sessionId: string;

  /**
   * annotations are key/value pairs attached to the environment metadata.
   *
   * @generated from field: map<string, string> annotations = 4;
   */
  annotations: { [key: string]: string };
};

/**
 * Describes the message gitpod.v1.CreateEnvironmentRequest.
 * Use `create(CreateEnvironmentRequestSchema)` to create a new message.
 */
export const CreateEnvironmentRequestSchema: GenMessage<CreateEnvironmentRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 7);

/**
 * @generated from message gitpod.v1.CreateEnvironmentResponse
 */
export type CreateEnvironmentResponse = Message<"gitpod.v1.CreateEnvironmentResponse"> & {
  /**
   * @generated from field: gitpod.v1.Environment environment = 1;
   */
  environment?: Environment;
};

/**
 * Describes the message gitpod.v1.CreateEnvironmentResponse.
 * Use `create(CreateEnvironmentResponseSchema)` to create a new message.
 */
export const CreateEnvironmentResponseSchema: GenMessage<CreateEnvironmentResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 8);

/**
 * @generated from message gitpod.v1.CreateEnvironmentFromProjectRequest
 */
export type CreateEnvironmentFromProjectRequest = Message<"gitpod.v1.CreateEnvironmentFromProjectRequest"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * Spec is the configuration of the environment that's required for the
   * runner to start the environment
   * Configuration already defined in the Project will override parts of the spec, if set
   *
   * @generated from field: gitpod.v1.EnvironmentSpec spec = 3;
   */
  spec?: EnvironmentSpec;

  /**
   * name is a user-defined identifier for the environment.
   * If not specified, the system will generate a name.
   *
   * @generated from field: optional string name = 4;
   */
  name?: string;

  /**
   * annotations are key/value pairs attached to the environment metadata.
   *
   * @generated from field: map<string, string> annotations = 5;
   */
  annotations: { [key: string]: string };

  /**
   * session_id is the ID of the session this environment belongs to.
   * If empty, a new session is created implicitly.
   *
   * @generated from field: string session_id = 6;
   */
  sessionId: string;
};

/**
 * Describes the message gitpod.v1.CreateEnvironmentFromProjectRequest.
 * Use `create(CreateEnvironmentFromProjectRequestSchema)` to create a new message.
 */
export const CreateEnvironmentFromProjectRequestSchema: GenMessage<CreateEnvironmentFromProjectRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 9);

/**
 * @generated from message gitpod.v1.CreateEnvironmentFromProjectResponse
 */
export type CreateEnvironmentFromProjectResponse = Message<"gitpod.v1.CreateEnvironmentFromProjectResponse"> & {
  /**
   * @generated from field: gitpod.v1.Environment environment = 1;
   */
  environment?: Environment;
};

/**
 * Describes the message gitpod.v1.CreateEnvironmentFromProjectResponse.
 * Use `create(CreateEnvironmentFromProjectResponseSchema)` to create a new message.
 */
export const CreateEnvironmentFromProjectResponseSchema: GenMessage<CreateEnvironmentFromProjectResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 10);

/**
 * `CreateEnvironmentPreconditionFailureDetails` contains details about why a
 * `CreateEnvironment` or `CreateEnvironmentFromProject` request failed with failed_precondition.
 * The `missing_authentication_tokens_for_hosts` field lists the hosts for which the required authentication tokens were missing.
 *
 * @generated from message gitpod.v1.CreateEnvironmentPreconditionFailureDetails
 */
export type CreateEnvironmentPreconditionFailureDetails = Message<"gitpod.v1.CreateEnvironmentPreconditionFailureDetails"> & {
  /**
   * @generated from field: repeated string missing_authentication_tokens_for_hosts = 1;
   */
  missingAuthenticationTokensForHosts: string[];
};

/**
 * Describes the message gitpod.v1.CreateEnvironmentPreconditionFailureDetails.
 * Use `create(CreateEnvironmentPreconditionFailureDetailsSchema)` to create a new message.
 */
export const CreateEnvironmentPreconditionFailureDetailsSchema: GenMessage<CreateEnvironmentPreconditionFailureDetails> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 11);

/**
 * `CreateEnvironmentFromProjectBadRequestEnvironmentClassDetails` contains details about possible environment class IDs to use with this project.
 *
 * @generated from message gitpod.v1.CreateEnvironmentFromProjectBadRequestEnvironmentClassDetails
 */
export type CreateEnvironmentFromProjectBadRequestEnvironmentClassDetails = Message<"gitpod.v1.CreateEnvironmentFromProjectBadRequestEnvironmentClassDetails"> & {
  /**
   * environment_class_ids are the available environment class IDs to use with this project.
   *
   * @generated from field: repeated string environment_class_ids = 1;
   */
  environmentClassIds: string[];
};

/**
 * Describes the message gitpod.v1.CreateEnvironmentFromProjectBadRequestEnvironmentClassDetails.
 * Use `create(CreateEnvironmentFromProjectBadRequestEnvironmentClassDetailsSchema)` to create a new message.
 */
export const CreateEnvironmentFromProjectBadRequestEnvironmentClassDetailsSchema: GenMessage<CreateEnvironmentFromProjectBadRequestEnvironmentClassDetails> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 12);

/**
 * @generated from message gitpod.v1.UnarchiveEnvironmentRequest
 */
export type UnarchiveEnvironmentRequest = Message<"gitpod.v1.UnarchiveEnvironmentRequest"> & {
  /**
   * environment_id specifies the environment to unarchive.
   *
   * +required
   *
   * @generated from field: string environment_id = 1;
   */
  environmentId: string;
};

/**
 * Describes the message gitpod.v1.UnarchiveEnvironmentRequest.
 * Use `create(UnarchiveEnvironmentRequestSchema)` to create a new message.
 */
export const UnarchiveEnvironmentRequestSchema: GenMessage<UnarchiveEnvironmentRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 13);

/**
 * @generated from message gitpod.v1.UnarchiveEnvironmentResponse
 */
export type UnarchiveEnvironmentResponse = Message<"gitpod.v1.UnarchiveEnvironmentResponse"> & {
};

/**
 * Describes the message gitpod.v1.UnarchiveEnvironmentResponse.
 * Use `create(UnarchiveEnvironmentResponseSchema)` to create a new message.
 */
export const UnarchiveEnvironmentResponseSchema: GenMessage<UnarchiveEnvironmentResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 14);

/**
 * +resource get environment
 *
 * @generated from message gitpod.v1.Environment
 */
export type Environment = Message<"gitpod.v1.Environment"> & {
  /**
   * ID is a unique identifier of this environment. No other environment with the
   * same name must be managed by this environment manager
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Metadata is data associated with this environment that's required for other
   * parts of Gitpod to function
   *
   * @generated from field: gitpod.v1.EnvironmentMetadata metadata = 2;
   */
  metadata?: EnvironmentMetadata;

  /**
   * Spec is the configuration of the environment that's required for the
   * runner to start the environment
   *
   * @generated from field: gitpod.v1.EnvironmentSpec spec = 3;
   */
  spec?: EnvironmentSpec;

  /**
   * Status is the current status of the environment
   *
   * @generated from field: gitpod.v1.EnvironmentStatus status = 4;
   */
  status?: EnvironmentStatus;
};

/**
 * Describes the message gitpod.v1.Environment.
 * Use `create(EnvironmentSchema)` to create a new message.
 */
export const EnvironmentSchema: GenMessage<Environment> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 15);

/**
 * EnvironmentMetadata is data associated with an environment that's required for
 * other parts of the system to function
 *
 * @generated from message gitpod.v1.EnvironmentMetadata
 */
export type EnvironmentMetadata = Message<"gitpod.v1.EnvironmentMetadata"> & {
  /**
   * organization_id is the ID of the organization that contains the environment
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * annotations are key/value pairs that gets attached to the environment.
   * +internal - not yet implemented
   *
   * @generated from field: map<string, string> annotations = 2;
   */
  annotations: { [key: string]: string };

  /**
   * name is the name of the environment as specified by the user
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * creator is the identity of the creator of the environment
   *
   * @generated from field: gitpod.v1.Subject creator = 4;
   */
  creator?: Subject;

  /**
   * original_context_url is the normalized URL from which the environment was
   * created
   *
   * @generated from field: string original_context_url = 5;
   */
  originalContextUrl: string;

  /**
   * Time when the Environment was created.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  /**
   * If the Environment was started from a project, the project_id will reference the project.
   *
   * @generated from field: string project_id = 7;
   */
  projectId: string;

  /**
   * Runner is the ID of the runner that runs this environment.
   *
   * @generated from field: string runner_id = 9;
   */
  runnerId: string;

  /**
   * Time when the Environment was last started (i.e. CreateEnvironment or StartEnvironment were called).
   *
   * @generated from field: google.protobuf.Timestamp last_started_at = 10;
   */
  lastStartedAt?: Timestamp;

  /**
   * Time when the Environment was archived. If not set, the environment is not archived.
   *
   * @generated from field: google.protobuf.Timestamp archived_at = 11;
   */
  archivedAt?: Timestamp;

  /**
   * role is the role of the environment
   *
   * @generated from field: gitpod.v1.EnvironmentRole role = 12;
   */
  role: EnvironmentRole;

  /**
   * prebuild_id is the ID of the prebuild this environment was created from.
   * Only set if the environment was created from a prebuild.
   *
   * @generated from field: optional string prebuild_id = 13;
   */
  prebuildId?: string;

  /**
   * lockdown_at is the time at which the environment becomes locked down due
   * to the organization's maximum environment lifetime policy. Nil when no
   * lifetime policy applies.
   *
   * @generated from field: google.protobuf.Timestamp lockdown_at = 14;
   */
  lockdownAt?: Timestamp;

  /**
   * session_id is the ID of the session this environment belongs to.
   *
   * @generated from field: string session_id = 15;
   */
  sessionId: string;
};

/**
 * Describes the message gitpod.v1.EnvironmentMetadata.
 * Use `create(EnvironmentMetadataSchema)` to create a new message.
 */
export const EnvironmentMetadataSchema: GenMessage<EnvironmentMetadata> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 16);

/**
 * Veto controls kernel-level blocking mechanisms
 *
 * @generated from message gitpod.v1.Veto
 */
export type Veto = Message<"gitpod.v1.Veto"> & {
  /**
   * exec controls executable blocking
   *
   * @generated from field: gitpod.v1.Veto.Exec exec = 1;
   */
  exec?: Veto_Exec;
};

/**
 * Describes the message gitpod.v1.Veto.
 * Use `create(VetoSchema)` to create a new message.
 */
export const VetoSchema: GenMessage<Veto> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 17);

/**
 * Exec controls executable blocking
 *
 * @generated from message gitpod.v1.Veto.Exec
 */
export type Veto_Exec = Message<"gitpod.v1.Veto.Exec"> & {
  /**
   * enabled controls whether executable blocking is active
   *
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * denylist is the list of executable paths or names to block
   *
   * @generated from field: repeated string denylist = 2;
   */
  denylist: string[];

  /**
   * action specifies what action kernel-level controls take on policy violations
   *
   * @generated from field: gitpod.v1.KernelControlsAction action = 3;
   */
  action: KernelControlsAction;

  /**
   * resolve_bare_names enables the discovery agent to resolve bare executable
   * names in the denylist to full filesystem paths. Gated by a feature flag
   * for incremental rollout.
   *
   * @generated from field: bool resolve_bare_names = 4;
   */
  resolveBareNames: boolean;

  /**
   * untouchable enables file I/O blocking on denylisted files. When true,
   * every read()/write() on a denylisted file is blocked via the
   * security_file_permission LSM hook. Gated by a feature flag.
   *
   * @generated from field: bool untouchable = 5;
   */
  untouchable: boolean;

  /**
   * watch enables the BPF file watcher that emits events when denylisted
   * files are modified, unlinked, or renamed. Used by the self-healing
   * responder to keep the hash denylist up to date.
   *
   * @generated from field: bool watch = 6;
   */
  watch: boolean;

  /**
   * deny_block_devices blocks opening of block devices (S_ISBLK) system-wide
   * inside the environment. Prevents direct disk access. Gated by a feature flag.
   *
   * @generated from field: bool deny_block_devices = 7;
   */
  denyBlockDevices: boolean;
};

/**
 * Describes the message gitpod.v1.Veto.Exec.
 * Use `create(Veto_ExecSchema)` to create a new message.
 */
export const Veto_ExecSchema: GenMessage<Veto_Exec> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 17, 0);

/**
 * KernelControlsConfig configures kernel-level controls for the environment
 *
 * @generated from message gitpod.v1.KernelControlsConfig
 */
export type KernelControlsConfig = Message<"gitpod.v1.KernelControlsConfig"> & {
  /**
   * veto controls blocking mechanisms
   *
   * @generated from field: gitpod.v1.Veto veto = 1;
   */
  veto?: Veto;

  /**
   * bpf_debug_level controls the verbosity of BPF trace_pipe output
   * for all BPF-based agents in this environment.
   *
   * @generated from field: gitpod.v1.BPFDebugLevel bpf_debug_level = 2;
   */
  bpfDebugLevel: BPFDebugLevel;
};

/**
 * Describes the message gitpod.v1.KernelControlsConfig.
 * Use `create(KernelControlsConfigSchema)` to create a new message.
 */
export const KernelControlsConfigSchema: GenMessage<KernelControlsConfig> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 18);

/**
 * EnvironmentSpec specifies the configuration of an environment for an environment
 * start
 *
 * @generated from message gitpod.v1.EnvironmentSpec
 */
export type EnvironmentSpec = Message<"gitpod.v1.EnvironmentSpec"> & {
  /**
   * version of the spec. The value of this field has no semantic
   * meaning (e.g. don't interpret it as as a timestamp),
   * but it can be used to impose a partial order. If a.spec_version <
   * b.spec_version then a was the spec before b.
   *
   * @generated from field: uint64 spec_version = 1;
   */
  specVersion: bigint;

  /**
   * Phase is the desired phase of the environment
   *
   * @generated from field: gitpod.v1.EnvironmentPhase desired_phase = 2;
   */
  desiredPhase: EnvironmentPhase;

  /**
   * machine is the machine spec of the environment
   *
   * @generated from field: gitpod.v1.EnvironmentSpec.Machine machine = 3;
   */
  machine?: EnvironmentSpec_Machine;

  /**
   * content is the content spec of the environment
   *
   * @generated from field: gitpod.v1.EnvironmentSpec.Content content = 4;
   */
  content?: EnvironmentSpec_Content;

  /**
   * secrets are confidential data that is mounted into the environment
   *
   * @generated from field: repeated gitpod.v1.EnvironmentSpec.Secret secrets = 5;
   */
  secrets: EnvironmentSpec_Secret[];

  /**
   * ports is the set of ports which ought to be exposed to your network
   *
   * @generated from field: repeated gitpod.v1.EnvironmentSpec.EnvironmentPort ports = 6;
   */
  ports: EnvironmentSpec_EnvironmentPort[];

  /**
   * Timeout configures the environment timeout
   *
   * @generated from field: gitpod.v1.EnvironmentSpec.Timeout timeout = 7;
   */
  timeout?: EnvironmentSpec_Timeout;

  /**
   * admission controlls who can access the environment and its ports.
   *
   * @generated from field: gitpod.v1.AdmissionLevel admission = 8;
   */
  admission: AdmissionLevel;

  /**
   * devcontainer is the devcontainer spec of the environment
   *
   * @generated from field: gitpod.v1.EnvironmentSpec.DevContainer devcontainer = 9;
   */
  devcontainer?: EnvironmentSpec_DevContainer;

  /**
   * ssh_public_keys are the public keys used to ssh into the environment
   *
   * @generated from field: repeated gitpod.v1.EnvironmentSpec.SSHPublicKey ssh_public_keys = 10;
   */
  sshPublicKeys: EnvironmentSpec_SSHPublicKey[];

  /**
   * automations_file is the automations file spec of the environment
   *
   * @generated from field: gitpod.v1.EnvironmentSpec.AutomationsFile automations_file = 11;
   */
  automationsFile?: EnvironmentSpec_AutomationsFile;

  /**
   * workflow_action_id is an optional reference to the workflow execution action
   * that created this environment. Used for tracking and event correlation.
   *
   * @generated from field: optional string workflow_action_id = 12;
   */
  workflowActionId?: string;

  /**
   * kernel_controls_config configures kernel-level controls for this environment
   *
   * @generated from field: gitpod.v1.KernelControlsConfig kernel_controls_config = 13;
   */
  kernelControlsConfig?: KernelControlsConfig;
};

/**
 * Describes the message gitpod.v1.EnvironmentSpec.
 * Use `create(EnvironmentSpecSchema)` to create a new message.
 */
export const EnvironmentSpecSchema: GenMessage<EnvironmentSpec> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 19);

/**
 * Timeout configures the environment timeout
 *
 * @generated from message gitpod.v1.EnvironmentSpec.Timeout
 */
export type EnvironmentSpec_Timeout = Message<"gitpod.v1.EnvironmentSpec.Timeout"> & {
  /**
   * inacitivity is the maximum time of disconnection before the environment is
   * stopped or paused. Minimum duration is 30 minutes. Set to 0 to disable.
   *
   * @generated from field: google.protobuf.Duration disconnected = 2;
   */
  disconnected?: Duration;
};

/**
 * Describes the message gitpod.v1.EnvironmentSpec.Timeout.
 * Use `create(EnvironmentSpec_TimeoutSchema)` to create a new message.
 */
export const EnvironmentSpec_TimeoutSchema: GenMessage<EnvironmentSpec_Timeout> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 19, 0);

/**
 * @generated from message gitpod.v1.EnvironmentSpec.Machine
 */
export type EnvironmentSpec_Machine = Message<"gitpod.v1.EnvironmentSpec.Machine"> & {
  /**
   * @generated from field: string session = 1;
   */
  session: string;

  /**
   * Class denotes the class of the environment we ought to start
   *
   * @generated from field: string class = 2;
   */
  class: string;

  /**
   * prefer_dual_disk indicates the management plane wants this environment
   * to use a dual-disk layout (separate system and data disks). The runner
   * may ignore this if it does not support dual-disk.
   *
   * @generated from field: bool prefer_dual_disk = 3;
   */
  preferDualDisk: boolean;
};

/**
 * Describes the message gitpod.v1.EnvironmentSpec.Machine.
 * Use `create(EnvironmentSpec_MachineSchema)` to create a new message.
 */
export const EnvironmentSpec_MachineSchema: GenMessage<EnvironmentSpec_Machine> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 19, 1);

/**
 * @generated from message gitpod.v1.EnvironmentSpec.Content
 */
export type EnvironmentSpec_Content = Message<"gitpod.v1.EnvironmentSpec.Content"> & {
  /**
   * @generated from field: string session = 1;
   */
  session: string;

  /**
   * initializer configures how the environment is to be initialized
   *
   * @generated from field: gitpod.v1.EnvironmentInitializer initializer = 2;
   */
  initializer?: EnvironmentInitializer;

  /**
   * The Git username
   *
   * @generated from field: string git_username = 3;
   */
  gitUsername: string;

  /**
   * The Git email address
   *
   * @generated from field: string git_email = 4;
   */
  gitEmail: string;
};

/**
 * Describes the message gitpod.v1.EnvironmentSpec.Content.
 * Use `create(EnvironmentSpec_ContentSchema)` to create a new message.
 */
export const EnvironmentSpec_ContentSchema: GenMessage<EnvironmentSpec_Content> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 19, 2);

/**
 * @generated from message gitpod.v1.EnvironmentSpec.DevContainer
 */
export type EnvironmentSpec_DevContainer = Message<"gitpod.v1.EnvironmentSpec.DevContainer"> & {
  /**
   * @generated from field: string session = 1;
   */
  session: string;

  /**
   * devcontainer_file_path is the path to the devcontainer file relative to the repo root
   *
   * @generated from field: string devcontainer_file_path = 2;
   */
  devcontainerFilePath: string;

  /**
   * Experimental: dotfiles is the dotfiles configuration of the devcontainer
   *
   * @generated from field: gitpod.v1.EnvironmentSpec.DevContainer.Dotfiles dotfiles = 3;
   */
  dotfiles?: EnvironmentSpec_DevContainer_Dotfiles;

  /**
   * default_devcontainer_image is the default image that is used to start the devcontainer if no devcontainer config file is found
   *
   * @generated from field: string default_devcontainer_image = 4;
   */
  defaultDevcontainerImage: string;

  /**
   * lifecycle_stage controls which devcontainer lifecycle commands are executed.
   * Defaults to FULL if not specified.
   *
   * @generated from field: gitpod.v1.EnvironmentSpec.DevContainer.LifecycleStage lifecycle_stage = 5;
   */
  lifecycleStage: EnvironmentSpec_DevContainer_LifecycleStage;
};

/**
 * Describes the message gitpod.v1.EnvironmentSpec.DevContainer.
 * Use `create(EnvironmentSpec_DevContainerSchema)` to create a new message.
 */
export const EnvironmentSpec_DevContainerSchema: GenMessage<EnvironmentSpec_DevContainer> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 19, 3);

/**
 * @generated from message gitpod.v1.EnvironmentSpec.DevContainer.Dotfiles
 */
export type EnvironmentSpec_DevContainer_Dotfiles = Message<"gitpod.v1.EnvironmentSpec.DevContainer.Dotfiles"> & {
  /**
   * URL of a dotfiles Git repository (e.g. https://github.com/owner/repository)
   *
   * @generated from field: string repository = 1;
   */
  repository: string;
};

/**
 * Describes the message gitpod.v1.EnvironmentSpec.DevContainer.Dotfiles.
 * Use `create(EnvironmentSpec_DevContainer_DotfilesSchema)` to create a new message.
 */
export const EnvironmentSpec_DevContainer_DotfilesSchema: GenMessage<EnvironmentSpec_DevContainer_Dotfiles> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 19, 3, 0);

/**
 * LifecycleStage controls which devcontainer lifecycle commands are executed.
 * See https://containers.dev/implementors/json_reference/#lifecycle-scripts
 *
 * @generated from enum gitpod.v1.EnvironmentSpec.DevContainer.LifecycleStage
 */
export enum EnvironmentSpec_DevContainer_LifecycleStage {
  /**
   * LIFECYCLE_STAGE_UNSPECIFIED defaults to FULL for backward compatibility
   *
   * @generated from enum value: LIFECYCLE_STAGE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * LIFECYCLE_STAGE_FULL runs all devcontainer lifecycle commands (default):
   * initializeCommand, onCreateCommand, updateContentCommand, postCreateCommand,
   * postStartCommand, and postAttachCommand.
   *
   * @generated from enum value: LIFECYCLE_STAGE_FULL = 1;
   */
  FULL = 1,

  /**
   * LIFECYCLE_STAGE_PREBUILD runs only the lifecycle commands suitable for prebuilding:
   * initializeCommand, onCreateCommand, and updateContentCommand.
   * Skips postCreateCommand, postStartCommand, and postAttachCommand which are
   * intended to run when a user connects to the container.
   *
   * @generated from enum value: LIFECYCLE_STAGE_PREBUILD = 2;
   */
  PREBUILD = 2,
}

/**
 * Describes the enum gitpod.v1.EnvironmentSpec.DevContainer.LifecycleStage.
 */
export const EnvironmentSpec_DevContainer_LifecycleStageSchema: GenEnum<EnvironmentSpec_DevContainer_LifecycleStage> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_environment, 19, 3, 0);

/**
 * @generated from message gitpod.v1.EnvironmentSpec.Secret
 */
export type EnvironmentSpec_Secret = Message<"gitpod.v1.EnvironmentSpec.Secret"> & {
  /**
   * name is the human readable description of the secret
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * source is the source of the secret, for now control-plane or runner
   *
   * @generated from field: string source = 2;
   */
  source: string;

  /**
   * source_ref into the source, in case of control-plane this is uuid of the secret
   *
   * @generated from field: string source_ref = 3;
   */
  sourceRef: string;

  /**
   * mount specifies how the secret is materiaized in the environment
   *
   * @generated from oneof gitpod.v1.EnvironmentSpec.Secret.mount
   */
  mount: {
    /**
     * file_path is the path inside the devcontainer where the secret is mounted
     *
     * @generated from field: string file_path = 10;
     */
    value: string;
    case: "filePath";
  } | {
    /**
     * @generated from field: string environment_variable = 11;
     */
    value: string;
    case: "environmentVariable";
  } | {
    /**
     * @generated from field: string git_credential_host = 12;
     */
    value: string;
    case: "gitCredentialHost";
  } | {
    /**
     * container_registry_basic_auth_host is the hostname of the container registry that supports basic auth
     *
     * @generated from field: string container_registry_basic_auth_host = 13;
     */
    value: string;
    case: "containerRegistryBasicAuthHost";
  } | {
    /**
     * api_only indicates the secret is only available via API/CLI.
     * These secrets are resolved but NOT automatically injected into services or devcontainers.
     *
     * @generated from field: bool api_only = 14;
     */
    value: boolean;
    case: "apiOnly";
  } | { case: undefined; value?: undefined };

  /**
   * session indicated the current session of the secret.
   * When the session does not change, secrets are not reloaded in the environment.
   *
   * @generated from field: string session = 4;
   */
  session: string;

  /**
   * id is the unique identifier of the secret.
   *
   * @generated from field: string id = 5;
   */
  id: string;

  /**
   * scope indicates where this secret originated from.
   * Used to filter secrets during build (only org and project secrets are injected).
   *
   * @generated from field: gitpod.v1.EnvironmentSpec.Secret.Scope scope = 6;
   */
  scope: EnvironmentSpec_Secret_Scope;

  /**
   * credential_proxy configures transparent credential injection via the
   * credential proxy. When set, the credential proxy intercepts HTTPS
   * traffic to the target hosts and replaces the dummy secret value with
   * the real value in the specified HTTP header. The real secret value is
   * never exposed in the environment.
   * This field is orthogonal to mount — a secret can be both mounted (e.g.
   * as a git credential) and proxied at the same time.
   *
   * @generated from field: gitpod.v1.EnvironmentSpec.Secret.CredentialProxy credential_proxy = 15;
   */
  credentialProxy?: EnvironmentSpec_Secret_CredentialProxy;
};

/**
 * Describes the message gitpod.v1.EnvironmentSpec.Secret.
 * Use `create(EnvironmentSpec_SecretSchema)` to create a new message.
 */
export const EnvironmentSpec_SecretSchema: GenMessage<EnvironmentSpec_Secret> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 19, 4);

/**
 * CredentialProxy describes how the credential proxy should inject this
 * secret into outgoing HTTPS requests.
 *
 * @generated from message gitpod.v1.EnvironmentSpec.Secret.CredentialProxy
 */
export type EnvironmentSpec_Secret_CredentialProxy = Message<"gitpod.v1.EnvironmentSpec.Secret.CredentialProxy"> & {
  /**
   * target_hosts lists the hostnames to intercept (for example
   * "github.com" or "*.github.com"). Wildcards are subdomain-only and
   * do not match the apex domain.
   *
   * @generated from field: repeated string target_hosts = 1;
   */
  targetHosts: string[];

  /**
   * header is the HTTP header name to inject (e.g. "Authorization").
   *
   * @generated from field: string header = 2;
   */
  header: string;

  /**
   * format describes how the secret value is encoded. The proxy uses
   * this to decode the value before injecting it into the header.
   *
   * @generated from field: gitpod.v1.EnvironmentSpec.Secret.CredentialProxy.Format format = 3;
   */
  format: EnvironmentSpec_Secret_CredentialProxy_Format;
};

/**
 * Describes the message gitpod.v1.EnvironmentSpec.Secret.CredentialProxy.
 * Use `create(EnvironmentSpec_Secret_CredentialProxySchema)` to create a new message.
 */
export const EnvironmentSpec_Secret_CredentialProxySchema: GenMessage<EnvironmentSpec_Secret_CredentialProxy> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 19, 4, 0);

/**
 * @generated from enum gitpod.v1.EnvironmentSpec.Secret.CredentialProxy.Format
 */
export enum EnvironmentSpec_Secret_CredentialProxy_Format {
  /**
   * @generated from enum value: FORMAT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * FORMAT_PLAIN means the value is used as-is.
   *
   * @generated from enum value: FORMAT_PLAIN = 1;
   */
  PLAIN = 1,

  /**
   * FORMAT_BASE64 means the value is base64-encoded and the proxy
   * must decode it before injecting.
   *
   * @generated from enum value: FORMAT_BASE64 = 2;
   */
  BASE64 = 2,
}

/**
 * Describes the enum gitpod.v1.EnvironmentSpec.Secret.CredentialProxy.Format.
 */
export const EnvironmentSpec_Secret_CredentialProxy_FormatSchema: GenEnum<EnvironmentSpec_Secret_CredentialProxy_Format> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_environment, 19, 4, 0, 0);

/**
 * Scope indicates the origin of the secret for filtering purposes.
 *
 * @generated from enum gitpod.v1.EnvironmentSpec.Secret.Scope
 */
export enum EnvironmentSpec_Secret_Scope {
  /**
   * @generated from enum value: SCOPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SCOPE_ORGANIZATION = 1;
   */
  ORGANIZATION = 1,

  /**
   * @generated from enum value: SCOPE_PROJECT = 2;
   */
  PROJECT = 2,

  /**
   * @generated from enum value: SCOPE_USER = 3;
   */
  USER = 3,

  /**
   * @generated from enum value: SCOPE_SERVICE_ACCOUNT = 4;
   */
  SERVICE_ACCOUNT = 4,

  /**
   * @generated from enum value: SCOPE_RUNNER = 5;
   */
  RUNNER = 5,
}

/**
 * Describes the enum gitpod.v1.EnvironmentSpec.Secret.Scope.
 */
export const EnvironmentSpec_Secret_ScopeSchema: GenEnum<EnvironmentSpec_Secret_Scope> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_environment, 19, 4, 0);

/**
 * @generated from message gitpod.v1.EnvironmentSpec.EnvironmentPort
 */
export type EnvironmentSpec_EnvironmentPort = Message<"gitpod.v1.EnvironmentSpec.EnvironmentPort"> & {
  /**
   * port number
   *
   * @generated from field: int32 port = 1;
   */
  port: number;

  /**
   * policy of this port
   *
   * @generated from field: gitpod.v1.AdmissionLevel admission = 2;
   */
  admission: AdmissionLevel;

  /**
   * name of this port
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * protocol for communication (Gateway proxy → user environment service).
   * this setting only affects the protocol used between Gateway and user environment services.
   *
   * @generated from field: gitpod.v1.EnvironmentSpec.EnvironmentPort.Protocol protocol = 4;
   */
  protocol: EnvironmentSpec_EnvironmentPort_Protocol;

  /**
   * auth_nonce is a monotonically increasing counter incremented by the
   * backend whenever the port's admission level changes. Used by the proxy
   * to invalidate browser auth cookies without requiring a backend round-trip.
   *
   * @generated from field: uint64 auth_nonce = 5;
   */
  authNonce: bigint;
};

/**
 * Describes the message gitpod.v1.EnvironmentSpec.EnvironmentPort.
 * Use `create(EnvironmentSpec_EnvironmentPortSchema)` to create a new message.
 */
export const EnvironmentSpec_EnvironmentPortSchema: GenMessage<EnvironmentSpec_EnvironmentPort> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 19, 5);

/**
 * Protocol describes the communication protocol between Gateway and user environment services.
 *
 * @generated from enum gitpod.v1.EnvironmentSpec.EnvironmentPort.Protocol
 */
export enum EnvironmentSpec_EnvironmentPort_Protocol {
  /**
   * defaults to HTTP for backward compatibility
   *
   * @generated from enum value: PROTOCOL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PROTOCOL_HTTP = 1;
   */
  HTTP = 1,

  /**
   * @generated from enum value: PROTOCOL_HTTPS = 2;
   */
  HTTPS = 2,
}

/**
 * Describes the enum gitpod.v1.EnvironmentSpec.EnvironmentPort.Protocol.
 */
export const EnvironmentSpec_EnvironmentPort_ProtocolSchema: GenEnum<EnvironmentSpec_EnvironmentPort_Protocol> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_environment, 19, 5, 0);

/**
 * @generated from message gitpod.v1.EnvironmentSpec.SSHPublicKey
 */
export type EnvironmentSpec_SSHPublicKey = Message<"gitpod.v1.EnvironmentSpec.SSHPublicKey"> & {
  /**
   * id is the unique identifier of the public key
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * value is the actual public key in the public key file format
   *
   * @generated from field: string value = 2;
   */
  value: string;
};

/**
 * Describes the message gitpod.v1.EnvironmentSpec.SSHPublicKey.
 * Use `create(EnvironmentSpec_SSHPublicKeySchema)` to create a new message.
 */
export const EnvironmentSpec_SSHPublicKeySchema: GenMessage<EnvironmentSpec_SSHPublicKey> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 19, 6);

/**
 * @generated from message gitpod.v1.EnvironmentSpec.AutomationsFile
 */
export type EnvironmentSpec_AutomationsFile = Message<"gitpod.v1.EnvironmentSpec.AutomationsFile"> & {
  /**
   * @generated from field: string session = 1;
   */
  session: string;

  /**
   * automations_file_path is the path to the automations file that is applied in the environment,
   * relative to the repo root.
   *
   * @generated from field: string automations_file_path = 2;
   */
  automationsFilePath: string;

  /**
   * trigger_filter specifies which automation triggers should execute.
   * When set, only automations matching these triggers will run.
   * If empty/unset, all triggers are evaluated normally.
   *
   * @generated from field: repeated gitpod.v1.AutomationTrigger trigger_filter = 3;
   */
  triggerFilter: AutomationTrigger[];
};

/**
 * Describes the message gitpod.v1.EnvironmentSpec.AutomationsFile.
 * Use `create(EnvironmentSpec_AutomationsFileSchema)` to create a new message.
 */
export const EnvironmentSpec_AutomationsFileSchema: GenMessage<EnvironmentSpec_AutomationsFile> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 19, 7);

/**
 * EnvironmentStatus describes an environment status
 *
 * @generated from message gitpod.v1.EnvironmentStatus
 */
export type EnvironmentStatus = Message<"gitpod.v1.EnvironmentStatus"> & {
  /**
   * version of the status update. Environment instances themselves are
   * unversioned, but their status has different versions. The value of this
   * field has no semantic meaning (e.g. don't interpret it as as a timestamp),
   * but it can be used to impose a partial order. If a.status_version <
   * b.status_version then a was the status before b.
   *
   * @generated from field: uint64 status_version = 1;
   */
  statusVersion: bigint;

  /**
   * runner_ack contains the acknowledgement from the runner that is has
   * received the environment spec.
   *
   * @generated from field: gitpod.v1.EnvironmentStatus.RunnerACK runner_ack = 2;
   */
  runnerAck?: EnvironmentStatus_RunnerACK;

  /**
   * the phase of an environment is a simple, high-level summary of where the
   * environment is in its lifecycle
   *
   * @generated from field: gitpod.v1.EnvironmentPhase phase = 3;
   */
  phase: EnvironmentPhase;

  /**
   * failure_message summarises why the environment failed to operate. If this is non-empty
   * the environment has failed to operate and will likely transition to a stopped state.
   *
   * @generated from field: repeated string failure_message = 4;
   */
  failureMessage: string[];

  /**
   * environment_url contains the URL at which the environment can be accessed.
   * This field is only set if the environment is running.
   *
   * @generated from field: gitpod.v1.EnvironmentStatus.EnvironmentURLs environment_urls = 5;
   */
  environmentUrls?: EnvironmentStatus_EnvironmentURLs;

  /**
   * machine contains the status of the environment machine
   *
   * @generated from field: gitpod.v1.EnvironmentStatus.Machine machine = 6;
   */
  machine?: EnvironmentStatus_Machine;

  /**
   * secrets contains the status of the environment secrets
   *
   * @generated from field: repeated gitpod.v1.EnvironmentStatus.Secret secrets = 7;
   */
  secrets: EnvironmentStatus_Secret[];

  /**
   * content contains the status of the environment content.
   *
   * @generated from field: gitpod.v1.EnvironmentStatus.Content content = 8;
   */
  content?: EnvironmentStatus_Content;

  /**
   * devcontainer contains the status of the devcontainer.
   *
   * @generated from field: gitpod.v1.EnvironmentStatus.DevContainer devcontainer = 9;
   */
  devcontainer?: EnvironmentStatus_DevContainer;

  /**
   * ssh_public_keys contains the status of the environment ssh public keys
   *
   * @generated from field: repeated gitpod.v1.EnvironmentStatus.SSHPublicKey ssh_public_keys = 10;
   */
  sshPublicKeys: EnvironmentStatus_SSHPublicKey[];

  /**
   * warning_message contains warnings, e.g. when the environment is present but not in the expected state.
   *
   * @generated from field: repeated string warning_message = 11;
   */
  warningMessage: string[];

  /**
   * automations_file contains the status of the automations file.
   *
   * @generated from field: gitpod.v1.EnvironmentStatus.AutomationsFile automations_file = 12;
   */
  automationsFile?: EnvironmentStatus_AutomationsFile;

  /**
   * activity_signal is the last activity signal for the environment.
   *
   * @generated from field: gitpod.v1.EnvironmentActivitySignal activity_signal = 13;
   */
  activitySignal?: EnvironmentActivitySignal;
};

/**
 * Describes the message gitpod.v1.EnvironmentStatus.
 * Use `create(EnvironmentStatusSchema)` to create a new message.
 */
export const EnvironmentStatusSchema: GenMessage<EnvironmentStatus> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 20);

/**
 * @generated from message gitpod.v1.EnvironmentStatus.EnvironmentPortURL
 */
export type EnvironmentStatus_EnvironmentPortURL = Message<"gitpod.v1.EnvironmentStatus.EnvironmentPortURL"> & {
  /**
   * port is the port number of the environment port
   *
   * @generated from field: int32 port = 1;
   */
  port: number;

  /**
   * url is the URL at which the environment port can be accessed
   *
   * @generated from field: string url = 2;
   */
  url: string;
};

/**
 * Describes the message gitpod.v1.EnvironmentStatus.EnvironmentPortURL.
 * Use `create(EnvironmentStatus_EnvironmentPortURLSchema)` to create a new message.
 */
export const EnvironmentStatus_EnvironmentPortURLSchema: GenMessage<EnvironmentStatus_EnvironmentPortURL> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 20, 0);

/**
 * @generated from message gitpod.v1.EnvironmentStatus.EnvironmentSSHURL
 */
export type EnvironmentStatus_EnvironmentSSHURL = Message<"gitpod.v1.EnvironmentStatus.EnvironmentSSHURL"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;
};

/**
 * Describes the message gitpod.v1.EnvironmentStatus.EnvironmentSSHURL.
 * Use `create(EnvironmentStatus_EnvironmentSSHURLSchema)` to create a new message.
 */
export const EnvironmentStatus_EnvironmentSSHURLSchema: GenMessage<EnvironmentStatus_EnvironmentSSHURL> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 20, 1);

/**
 * @generated from message gitpod.v1.EnvironmentStatus.EnvironmentURLs
 */
export type EnvironmentStatus_EnvironmentURLs = Message<"gitpod.v1.EnvironmentStatus.EnvironmentURLs"> & {
  /**
   * SSH is the URL at which the environment can be accessed via SSH.
   *
   * @generated from field: gitpod.v1.EnvironmentStatus.EnvironmentSSHURL ssh = 1;
   */
  ssh?: EnvironmentStatus_EnvironmentSSHURL;

  /**
   * @generated from field: repeated gitpod.v1.EnvironmentStatus.EnvironmentPortURL ports = 2;
   */
  ports: EnvironmentStatus_EnvironmentPortURL[];

  /**
   * logs is the URL at which the environment logs can be accessed.
   *
   * @generated from field: string logs = 3;
   */
  logs: string;

  /**
   * support_bundle is the URL at which the environment support bundle can be accessed.
   *
   * @generated from field: string support_bundle = 4;
   */
  supportBundle: string;

  /**
   * ops is the URL at which the environment ops service can be accessed.
   *
   * @generated from field: string ops = 5;
   */
  ops: string;

  /**
   * vm_live_usage is the URL at which the environment's live VM resource usage can be accessed.
   *
   * @generated from field: string vm_live_usage = 6;
   */
  vmLiveUsage: string;
};

/**
 * Describes the message gitpod.v1.EnvironmentStatus.EnvironmentURLs.
 * Use `create(EnvironmentStatus_EnvironmentURLsSchema)` to create a new message.
 */
export const EnvironmentStatus_EnvironmentURLsSchema: GenMessage<EnvironmentStatus_EnvironmentURLs> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 20, 2);

/**
 * @generated from message gitpod.v1.EnvironmentStatus.Machine
 */
export type EnvironmentStatus_Machine = Message<"gitpod.v1.EnvironmentStatus.Machine"> & {
  /**
   * session is the session that is currently active in the machine.
   *
   * @generated from field: string session = 1;
   */
  session: string;

  /**
   * phase is the current phase of the environment machine
   *
   * @generated from field: gitpod.v1.EnvironmentStatus.Machine.Phase phase = 2;
   */
  phase: EnvironmentStatus_Machine_Phase;

  /**
   * failure_message contains the reason the machine failed to operate.
   *
   * @generated from field: string failure_message = 3;
   */
  failureMessage: string;

  /**
   * timeout contains the reason the environment has timed out. If this field is
   * empty, the environment has not timed out.
   *
   * @generated from field: string timeout = 4;
   */
  timeout: string;

  /**
   * versions contains the versions of components in the machine.
   *
   * @generated from field: gitpod.v1.EnvironmentStatus.Machine.Versions versions = 5;
   */
  versions?: EnvironmentStatus_Machine_Versions;

  /**
   * warning_message contains warnings, e.g. when the machine is present but not in the expected state.
   *
   * @generated from field: string warning_message = 6;
   */
  warningMessage: string;

  /**
   * dual_disk indicates the environment is running with a dual-disk layout
   * (separate system and data disks). Set by the runner based on actual
   * machine configuration.
   *
   * @generated from field: bool dual_disk = 7;
   */
  dualDisk: boolean;
};

/**
 * Describes the message gitpod.v1.EnvironmentStatus.Machine.
 * Use `create(EnvironmentStatus_MachineSchema)` to create a new message.
 */
export const EnvironmentStatus_MachineSchema: GenMessage<EnvironmentStatus_Machine> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 20, 3);

/**
 * @generated from message gitpod.v1.EnvironmentStatus.Machine.Versions
 */
export type EnvironmentStatus_Machine_Versions = Message<"gitpod.v1.EnvironmentStatus.Machine.Versions"> & {
  /**
   * @generated from field: string supervisor_version = 1;
   */
  supervisorVersion: string;

  /**
   * @generated from field: string supervisor_commit = 2;
   */
  supervisorCommit: string;

  /**
   * @generated from field: string ami_id = 3;
   */
  amiId: string;
};

/**
 * Describes the message gitpod.v1.EnvironmentStatus.Machine.Versions.
 * Use `create(EnvironmentStatus_Machine_VersionsSchema)` to create a new message.
 */
export const EnvironmentStatus_Machine_VersionsSchema: GenMessage<EnvironmentStatus_Machine_Versions> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 20, 3, 0);

/**
 * @generated from enum gitpod.v1.EnvironmentStatus.Machine.Phase
 */
export enum EnvironmentStatus_Machine_Phase {
  /**
   * @generated from enum value: PHASE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PHASE_CREATING = 10;
   */
  CREATING = 10,

  /**
   * @generated from enum value: PHASE_STARTING = 20;
   */
  STARTING = 20,

  /**
   * @generated from enum value: PHASE_RUNNING = 30;
   */
  RUNNING = 30,

  /**
   * @generated from enum value: PHASE_STOPPING = 40;
   */
  STOPPING = 40,

  /**
   * @generated from enum value: PHASE_STOPPED = 50;
   */
  STOPPED = 50,

  /**
   * @generated from enum value: PHASE_DELETING = 60;
   */
  DELETING = 60,

  /**
   * @generated from enum value: PHASE_DELETED = 70;
   */
  DELETED = 70,
}

/**
 * Describes the enum gitpod.v1.EnvironmentStatus.Machine.Phase.
 */
export const EnvironmentStatus_Machine_PhaseSchema: GenEnum<EnvironmentStatus_Machine_Phase> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_environment, 20, 3, 0);

/**
 * @generated from message gitpod.v1.EnvironmentStatus.Content
 */
export type EnvironmentStatus_Content = Message<"gitpod.v1.EnvironmentStatus.Content"> & {
  /**
   * session is the session that is currently active in the environment.
   *
   * @generated from field: string session = 1;
   */
  session: string;

  /**
   * phase is the current phase of the environment content
   *
   * @generated from field: gitpod.v1.EnvironmentStatus.ContentPhase phase = 2;
   */
  phase: EnvironmentStatus_ContentPhase;

  /**
   * git is the Git working copy status of the environment.
   * Note: this is a best-effort field and more often than not will not be
   * present. Its absence does not indicate the absence of a working copy.
   *
   * @generated from field: gitpod.v1.EnvironmentGitStatus git = 3;
   */
  git?: EnvironmentGitStatus;

  /**
   * content_location_in_machine is the location of the content in the machine
   *
   * @generated from field: string content_location_in_machine = 4;
   */
  contentLocationInMachine: string;

  /**
   * failure_message contains the reason the content initialization failed.
   *
   * @generated from field: string failure_message = 5;
   */
  failureMessage: string;

  /**
   * warning_message contains warnings, e.g. when the content is present but not in the expected state.
   *
   * @generated from field: string warning_message = 6;
   */
  warningMessage: string;
};

/**
 * Describes the message gitpod.v1.EnvironmentStatus.Content.
 * Use `create(EnvironmentStatus_ContentSchema)` to create a new message.
 */
export const EnvironmentStatus_ContentSchema: GenMessage<EnvironmentStatus_Content> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 20, 4);

/**
 * @generated from message gitpod.v1.EnvironmentStatus.Secret
 */
export type EnvironmentStatus_Secret = Message<"gitpod.v1.EnvironmentStatus.Secret"> & {
  /**
   * id is the unique identifier of the secret.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: gitpod.v1.EnvironmentStatus.ContentPhase phase = 2;
   */
  phase: EnvironmentStatus_ContentPhase;

  /**
   * @generated from field: string secret_name = 3;
   */
  secretName: string;

  /**
   * failure_message contains the reason the secret failed to be materialize.
   *
   * @generated from field: string failure_message = 4;
   */
  failureMessage: string;

  /**
   * warning_message contains warnings, e.g. when the secret is present but not in the expected state.
   *
   * @generated from field: string warning_message = 5;
   */
  warningMessage: string;

  /**
   * session is the session that is currently active in the environment.
   *
   * @generated from field: string session = 6;
   */
  session: string;
};

/**
 * Describes the message gitpod.v1.EnvironmentStatus.Secret.
 * Use `create(EnvironmentStatus_SecretSchema)` to create a new message.
 */
export const EnvironmentStatus_SecretSchema: GenMessage<EnvironmentStatus_Secret> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 20, 5);

/**
 * @generated from message gitpod.v1.EnvironmentStatus.DevContainer
 */
export type EnvironmentStatus_DevContainer = Message<"gitpod.v1.EnvironmentStatus.DevContainer"> & {
  /**
   * session is the session that is currently active in the devcontainer.
   *
   * @generated from field: string session = 1;
   */
  session: string;

  /**
   * phase is the current phase of the devcontainer
   *
   * @generated from field: gitpod.v1.EnvironmentStatus.DevContainer.Phase phase = 2;
   */
  phase: EnvironmentStatus_DevContainer_Phase;

  /**
   * devcontainer_file_path is the path to the devcontainer file relative to the repo root
   *
   * @generated from field: string devcontainer_file_path = 3;
   */
  devcontainerFilePath: string;

  /**
   * devcontainerconfig_in_sync indicates if the devcontainer is up to date w.r.t. the devcontainer config file.
   *
   * @generated from field: bool devcontainerconfig_in_sync = 4;
   */
  devcontainerconfigInSync: boolean;

  /**
   * secrets_in_sync indicates if the secrets are up to date w.r.t. the running devcontainer.
   *
   * @generated from field: bool secrets_in_sync = 5;
   */
  secretsInSync: boolean;

  /**
   * failure_message contains the reason the devcontainer failed to operate.
   *
   * @generated from field: string failure_message = 6;
   */
  failureMessage: string;

  /**
   * remote_user is the user that is used to connect to the devcontainer
   *
   * @generated from field: string remote_user = 7;
   */
  remoteUser: string;

  /**
   * remote_workspace_folder is the folder that is used to connect to the devcontainer
   *
   * @generated from field: string remote_workspace_folder = 8;
   */
  remoteWorkspaceFolder: string;

  /**
   * container_name is the name of the container that is used to connect to the devcontainer
   *
   * @generated from field: string container_name = 9;
   */
  containerName: string;

  /**
   * container_id is the ID of the container.
   *
   * @generated from field: string container_id = 10;
   */
  containerId: string;

  /**
   * warning_message contains warnings, e.g. when the devcontainer is present but not in the expected state.
   *
   * @generated from field: string warning_message = 12;
   */
  warningMessage: string;

  /**
   * devcontainer_file_presence indicates how the devcontainer file is present in the repo.
   *
   * @generated from field: gitpod.v1.EnvironmentStatus.DevContainer.Presence devcontainer_file_presence = 13;
   */
  devcontainerFilePresence: EnvironmentStatus_DevContainer_Presence;
};

/**
 * Describes the message gitpod.v1.EnvironmentStatus.DevContainer.
 * Use `create(EnvironmentStatus_DevContainerSchema)` to create a new message.
 */
export const EnvironmentStatus_DevContainerSchema: GenMessage<EnvironmentStatus_DevContainer> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 20, 6);

/**
 * @generated from enum gitpod.v1.EnvironmentStatus.DevContainer.Phase
 */
export enum EnvironmentStatus_DevContainer_Phase {
  /**
   * @generated from enum value: PHASE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PHASE_CREATING = 10;
   */
  CREATING = 10,

  /**
   * @generated from enum value: PHASE_RUNNING = 20;
   */
  RUNNING = 20,

  /**
   * @generated from enum value: PHASE_STOPPED = 30;
   */
  STOPPED = 30,

  /**
   * @generated from enum value: PHASE_FAILED = 40;
   */
  FAILED = 40,
}

/**
 * Describes the enum gitpod.v1.EnvironmentStatus.DevContainer.Phase.
 */
export const EnvironmentStatus_DevContainer_PhaseSchema: GenEnum<EnvironmentStatus_DevContainer_Phase> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_environment, 20, 6, 0);

/**
 * @generated from enum gitpod.v1.EnvironmentStatus.DevContainer.Presence
 */
export enum EnvironmentStatus_DevContainer_Presence {
  /**
   * @generated from enum value: PRESENCE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PRESENCE_GENERATED = 1;
   */
  GENERATED = 1,

  /**
   * @generated from enum value: PRESENCE_DISCOVERED = 2;
   */
  DISCOVERED = 2,

  /**
   * @generated from enum value: PRESENCE_SPECIFIED = 3;
   */
  SPECIFIED = 3,
}

/**
 * Describes the enum gitpod.v1.EnvironmentStatus.DevContainer.Presence.
 */
export const EnvironmentStatus_DevContainer_PresenceSchema: GenEnum<EnvironmentStatus_DevContainer_Presence> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_environment, 20, 6, 1);

/**
 * RunnerACK is the acknowledgement from the runner that is has received the
 * environment spec.
 *
 * @generated from message gitpod.v1.EnvironmentStatus.RunnerACK
 */
export type EnvironmentStatus_RunnerACK = Message<"gitpod.v1.EnvironmentStatus.RunnerACK"> & {
  /**
   * @generated from field: uint64 spec_version = 1;
   */
  specVersion: bigint;

  /**
   * @generated from field: gitpod.v1.EnvironmentStatus.RunnerACK.StatusCode status_code = 2;
   */
  statusCode: EnvironmentStatus_RunnerACK_StatusCode;

  /**
   * @generated from field: string message = 3;
   */
  message: string;
};

/**
 * Describes the message gitpod.v1.EnvironmentStatus.RunnerACK.
 * Use `create(EnvironmentStatus_RunnerACKSchema)` to create a new message.
 */
export const EnvironmentStatus_RunnerACKSchema: GenMessage<EnvironmentStatus_RunnerACK> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 20, 7);

/**
 * @generated from enum gitpod.v1.EnvironmentStatus.RunnerACK.StatusCode
 */
export enum EnvironmentStatus_RunnerACK_StatusCode {
  /**
   * @generated from enum value: STATUS_CODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: STATUS_CODE_OK = 1;
   */
  OK = 1,

  /**
   * @generated from enum value: STATUS_CODE_INVALID_RESOURCE = 2;
   */
  INVALID_RESOURCE = 2,

  /**
   * @generated from enum value: STATUS_CODE_FAILED_PRECONDITION = 3;
   */
  FAILED_PRECONDITION = 3,
}

/**
 * Describes the enum gitpod.v1.EnvironmentStatus.RunnerACK.StatusCode.
 */
export const EnvironmentStatus_RunnerACK_StatusCodeSchema: GenEnum<EnvironmentStatus_RunnerACK_StatusCode> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_environment, 20, 7, 0);

/**
 * @generated from message gitpod.v1.EnvironmentStatus.SSHPublicKey
 */
export type EnvironmentStatus_SSHPublicKey = Message<"gitpod.v1.EnvironmentStatus.SSHPublicKey"> & {
  /**
   * id is the unique identifier of the public key
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * phase is the current phase of the public key
   *
   * @generated from field: gitpod.v1.EnvironmentStatus.ContentPhase phase = 2;
   */
  phase: EnvironmentStatus_ContentPhase;
};

/**
 * Describes the message gitpod.v1.EnvironmentStatus.SSHPublicKey.
 * Use `create(EnvironmentStatus_SSHPublicKeySchema)` to create a new message.
 */
export const EnvironmentStatus_SSHPublicKeySchema: GenMessage<EnvironmentStatus_SSHPublicKey> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 20, 8);

/**
 * @generated from message gitpod.v1.EnvironmentStatus.AutomationsFile
 */
export type EnvironmentStatus_AutomationsFile = Message<"gitpod.v1.EnvironmentStatus.AutomationsFile"> & {
  /**
   * session is the automations file session that is currently applied in the environment.
   *
   * @generated from field: string session = 1;
   */
  session: string;

  /**
   * automations_file_path is the path to the automations file relative to the repo root.
   *
   * @generated from field: string automations_file_path = 2;
   */
  automationsFilePath: string;

  /**
   * phase is the current phase of the automations file.
   *
   * @generated from field: gitpod.v1.EnvironmentStatus.ContentPhase phase = 3;
   */
  phase: EnvironmentStatus_ContentPhase;

  /**
   * failure_message contains the reason the automations file failed to be applied.
   * This is only set if the phase is FAILED.
   *
   * @generated from field: string failure_message = 4;
   */
  failureMessage: string;

  /**
   * automations_file_presence indicates how an automations file is present in the environment.
   *
   * @generated from field: gitpod.v1.EnvironmentStatus.AutomationsFile.Presence automations_file_presence = 5;
   */
  automationsFilePresence: EnvironmentStatus_AutomationsFile_Presence;

  /**
   * warning_message contains warnings, e.g. when no triggers are defined in the automations file.
   *
   * @generated from field: string warning_message = 6;
   */
  warningMessage: string;
};

/**
 * Describes the message gitpod.v1.EnvironmentStatus.AutomationsFile.
 * Use `create(EnvironmentStatus_AutomationsFileSchema)` to create a new message.
 */
export const EnvironmentStatus_AutomationsFileSchema: GenMessage<EnvironmentStatus_AutomationsFile> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 20, 9);

/**
 * @generated from enum gitpod.v1.EnvironmentStatus.AutomationsFile.Presence
 */
export enum EnvironmentStatus_AutomationsFile_Presence {
  /**
   * @generated from enum value: PRESENCE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PRESENCE_ABSENT = 1;
   */
  ABSENT = 1,

  /**
   * @generated from enum value: PRESENCE_DISCOVERED = 2;
   */
  DISCOVERED = 2,

  /**
   * @generated from enum value: PRESENCE_SPECIFIED = 3;
   */
  SPECIFIED = 3,
}

/**
 * Describes the enum gitpod.v1.EnvironmentStatus.AutomationsFile.Presence.
 */
export const EnvironmentStatus_AutomationsFile_PresenceSchema: GenEnum<EnvironmentStatus_AutomationsFile_Presence> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_environment, 20, 9, 0);

/**
 * @generated from enum gitpod.v1.EnvironmentStatus.ContentPhase
 */
export enum EnvironmentStatus_ContentPhase {
  /**
   * @generated from enum value: CONTENT_PHASE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CONTENT_PHASE_CREATING = 10;
   */
  CREATING = 10,

  /**
   * @generated from enum value: CONTENT_PHASE_INITIALIZING = 20;
   */
  INITIALIZING = 20,

  /**
   * @generated from enum value: CONTENT_PHASE_READY = 30;
   */
  READY = 30,

  /**
   * @generated from enum value: CONTENT_PHASE_UPDATING = 35;
   */
  UPDATING = 35,

  /**
   * @generated from enum value: CONTENT_PHASE_FAILED = 40;
   */
  FAILED = 40,

  /**
   * @generated from enum value: CONTENT_PHASE_UNAVAILABLE = 45;
   */
  UNAVAILABLE = 45,
}

/**
 * Describes the enum gitpod.v1.EnvironmentStatus.ContentPhase.
 */
export const EnvironmentStatus_ContentPhaseSchema: GenEnum<EnvironmentStatus_ContentPhase> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_environment, 20, 0);

/**
 * @generated from message gitpod.v1.EnvironmentGitStatus
 */
export type EnvironmentGitStatus = Message<"gitpod.v1.EnvironmentGitStatus"> & {
  /**
   * clone_url is the repository url as you would pass it to "git clone".
   * Only HTTPS clone URLs are supported.
   *
   * @generated from field: string clone_url = 1;
   */
  cloneUrl: string;

  /**
   * branch is branch we're currently on
   *
   * @generated from field: string branch = 2;
   */
  branch: string;

  /**
   * latest_commit is the most recent commit on the current branch
   *
   * @generated from field: string latest_commit = 3;
   */
  latestCommit: string;

  /**
   * unpushed_commits is an array of unpushed changes in the environment, possibly
   * truncated
   *
   * @generated from field: repeated string unpushed_commits = 4;
   */
  unpushedCommits: string[];

  /**
   * the total number of unpushed changes
   *
   * @generated from field: int32 total_unpushed_commits = 5;
   */
  totalUnpushedCommits: number;

  /**
   * changed_files is an array of changed files in the environment, possibly
   * truncated
   *
   * @generated from field: repeated gitpod.v1.FileChange changed_files = 6;
   */
  changedFiles: FileChange[];

  /**
   * @generated from field: int32 total_changed_files = 7;
   */
  totalChangedFiles: number;
};

/**
 * Describes the message gitpod.v1.EnvironmentGitStatus.
 * Use `create(EnvironmentGitStatusSchema)` to create a new message.
 */
export const EnvironmentGitStatusSchema: GenMessage<EnvironmentGitStatus> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 21);

/**
 * @generated from message gitpod.v1.FileChange
 */
export type FileChange = Message<"gitpod.v1.FileChange"> & {
  /**
   * path is the path of the file
   *
   * @generated from field: string path = 1;
   */
  path: string;

  /**
   * @generated from field: gitpod.v1.FileChange.ChangeType change_type = 2;
   */
  changeType: FileChange_ChangeType;

  /**
   * old_path is the previous path of the file before a rename or copy.
   * Only set when change_type is RENAMED or COPIED.
   *
   * @generated from field: string old_path = 3;
   */
  oldPath: string;
};

/**
 * Describes the message gitpod.v1.FileChange.
 * Use `create(FileChangeSchema)` to create a new message.
 */
export const FileChangeSchema: GenMessage<FileChange> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 22);

/**
 * ChangeType is the type of change that happened to the file
 *
 * @generated from enum gitpod.v1.FileChange.ChangeType
 */
export enum FileChange_ChangeType {
  /**
   * @generated from enum value: CHANGE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CHANGE_TYPE_ADDED = 1;
   */
  ADDED = 1,

  /**
   * @generated from enum value: CHANGE_TYPE_MODIFIED = 2;
   */
  MODIFIED = 2,

  /**
   * @generated from enum value: CHANGE_TYPE_DELETED = 3;
   */
  DELETED = 3,

  /**
   * @generated from enum value: CHANGE_TYPE_RENAMED = 4;
   */
  RENAMED = 4,

  /**
   * @generated from enum value: CHANGE_TYPE_COPIED = 5;
   */
  COPIED = 5,

  /**
   * @generated from enum value: CHANGE_TYPE_UPDATED_BUT_UNMERGED = 6;
   */
  UPDATED_BUT_UNMERGED = 6,

  /**
   * @generated from enum value: CHANGE_TYPE_UNTRACKED = 7;
   */
  UNTRACKED = 7,
}

/**
 * Describes the enum gitpod.v1.FileChange.ChangeType.
 */
export const FileChange_ChangeTypeSchema: GenEnum<FileChange_ChangeType> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_environment, 22, 0);

/**
 * EnvironmentInitializer specifies how an environment is to be initialized
 *
 * @generated from message gitpod.v1.EnvironmentInitializer
 */
export type EnvironmentInitializer = Message<"gitpod.v1.EnvironmentInitializer"> & {
  /**
   * @generated from field: repeated gitpod.v1.EnvironmentInitializer.Spec specs = 1;
   */
  specs: EnvironmentInitializer_Spec[];
};

/**
 * Describes the message gitpod.v1.EnvironmentInitializer.
 * Use `create(EnvironmentInitializerSchema)` to create a new message.
 */
export const EnvironmentInitializerSchema: GenMessage<EnvironmentInitializer> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 23);

/**
 * @generated from message gitpod.v1.EnvironmentInitializer.Spec
 */
export type EnvironmentInitializer_Spec = Message<"gitpod.v1.EnvironmentInitializer.Spec"> & {
  /**
   * @generated from oneof gitpod.v1.EnvironmentInitializer.Spec.spec
   */
  spec: {
    /**
     * @generated from field: gitpod.v1.GitInitializer git = 1;
     */
    value: GitInitializer;
    case: "git";
  } | {
    /**
     * @generated from field: gitpod.v1.ContextURLInitializer context_url = 2;
     */
    value: ContextURLInitializer;
    case: "contextUrl";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message gitpod.v1.EnvironmentInitializer.Spec.
 * Use `create(EnvironmentInitializer_SpecSchema)` to create a new message.
 */
export const EnvironmentInitializer_SpecSchema: GenMessage<EnvironmentInitializer_Spec> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 23, 0);

/**
 * @generated from message gitpod.v1.ContextURLInitializer
 */
export type ContextURLInitializer = Message<"gitpod.v1.ContextURLInitializer"> & {
  /**
   * url is the URL from which the environment is created
   *
   * @generated from field: string url = 1;
   */
  url: string;
};

/**
 * Describes the message gitpod.v1.ContextURLInitializer.
 * Use `create(ContextURLInitializerSchema)` to create a new message.
 */
export const ContextURLInitializerSchema: GenMessage<ContextURLInitializer> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 24);

/**
 * @generated from message gitpod.v1.GitInitializer
 */
export type GitInitializer = Message<"gitpod.v1.GitInitializer"> & {
  /**
   * remote_uri is the Git remote origin
   *
   * @generated from field: string remote_uri = 1;
   */
  remoteUri: string;

  /**
   * upstream_Remote_uri is the fork upstream of a repository
   *
   * @generated from field: string upstream_remote_uri = 2;
   */
  upstreamRemoteUri: string;

  /**
   * the target mode determines what gets checked out
   *
   * @generated from field: gitpod.v1.GitInitializer.CloneTargetMode target_mode = 3;
   */
  targetMode: GitInitializer_CloneTargetMode;

  /**
   * the value for the clone target mode - use depends on the target mode
   *
   * @generated from field: string clone_target = 4;
   */
  cloneTarget: string;

  /**
   * a path relative to the environment root in which the code will be checked out
   * to
   *
   * @generated from field: string checkout_location = 5;
   */
  checkoutLocation: string;
};

/**
 * Describes the message gitpod.v1.GitInitializer.
 * Use `create(GitInitializerSchema)` to create a new message.
 */
export const GitInitializerSchema: GenMessage<GitInitializer> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 25);

/**
 * CloneTargetMode is the target state in which we want to leave a
 * GitEnvironment
 *
 * @generated from enum gitpod.v1.GitInitializer.CloneTargetMode
 */
export enum GitInitializer_CloneTargetMode {
  /**
   * @generated from enum value: CLONE_TARGET_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * REMOTE_HEAD has the local WS point at the remote branch head
   *
   * @generated from enum value: CLONE_TARGET_MODE_REMOTE_HEAD = 1;
   */
  REMOTE_HEAD = 1,

  /**
   * REMOTE_COMMIT has the local WS point at a specific commit
   *
   * @generated from enum value: CLONE_TARGET_MODE_REMOTE_COMMIT = 2;
   */
  REMOTE_COMMIT = 2,

  /**
   * REMOTE_BRANCH has the local WS point at a remote branch
   *
   * @generated from enum value: CLONE_TARGET_MODE_REMOTE_BRANCH = 3;
   */
  REMOTE_BRANCH = 3,

  /**
   * LOCAL_BRANCH creates a local branch in the environment
   *
   * @generated from enum value: CLONE_TARGET_MODE_LOCAL_BRANCH = 4;
   */
  LOCAL_BRANCH = 4,

  /**
   * REMOTE_TAG has the local WS point at a specific tag
   *
   * @generated from enum value: CLONE_TARGET_MODE_REMOTE_TAG = 5;
   */
  REMOTE_TAG = 5,
}

/**
 * Describes the enum gitpod.v1.GitInitializer.CloneTargetMode.
 */
export const GitInitializer_CloneTargetModeSchema: GenEnum<GitInitializer_CloneTargetMode> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_environment, 25, 0);

/**
 * @generated from message gitpod.v1.StartEnvironmentRequest
 */
export type StartEnvironmentRequest = Message<"gitpod.v1.StartEnvironmentRequest"> & {
  /**
   * environment_id specifies which environment should be started.
   *
   * @generated from field: string environment_id = 1;
   */
  environmentId: string;
};

/**
 * Describes the message gitpod.v1.StartEnvironmentRequest.
 * Use `create(StartEnvironmentRequestSchema)` to create a new message.
 */
export const StartEnvironmentRequestSchema: GenMessage<StartEnvironmentRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 26);

/**
 * @generated from message gitpod.v1.StartEnvironmentResponse
 */
export type StartEnvironmentResponse = Message<"gitpod.v1.StartEnvironmentResponse"> & {
};

/**
 * Describes the message gitpod.v1.StartEnvironmentResponse.
 * Use `create(StartEnvironmentResponseSchema)` to create a new message.
 */
export const StartEnvironmentResponseSchema: GenMessage<StartEnvironmentResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 27);

/**
 * @generated from message gitpod.v1.StopEnvironmentRequest
 */
export type StopEnvironmentRequest = Message<"gitpod.v1.StopEnvironmentRequest"> & {
  /**
   * environment_id specifies which environment should be stopped.
   *
   * +required
   *
   * @generated from field: string environment_id = 1;
   */
  environmentId: string;
};

/**
 * Describes the message gitpod.v1.StopEnvironmentRequest.
 * Use `create(StopEnvironmentRequestSchema)` to create a new message.
 */
export const StopEnvironmentRequestSchema: GenMessage<StopEnvironmentRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 28);

/**
 * @generated from message gitpod.v1.StopEnvironmentResponse
 */
export type StopEnvironmentResponse = Message<"gitpod.v1.StopEnvironmentResponse"> & {
};

/**
 * Describes the message gitpod.v1.StopEnvironmentResponse.
 * Use `create(StopEnvironmentResponseSchema)` to create a new message.
 */
export const StopEnvironmentResponseSchema: GenMessage<StopEnvironmentResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 29);

/**
 * @generated from message gitpod.v1.UpdateEnvironmentRequest
 */
export type UpdateEnvironmentRequest = Message<"gitpod.v1.UpdateEnvironmentRequest"> & {
  /**
   * environment_id specifies which environment should be updated.
   *
   * +required
   *
   * @generated from field: string environment_id = 1;
   */
  environmentId: string;

  /**
   * @generated from field: optional gitpod.v1.UpdateEnvironmentRequest.Metadata metadata = 2;
   */
  metadata?: UpdateEnvironmentRequest_Metadata;

  /**
   * @generated from field: optional gitpod.v1.UpdateEnvironmentRequest.Spec spec = 3;
   */
  spec?: UpdateEnvironmentRequest_Spec;
};

/**
 * Describes the message gitpod.v1.UpdateEnvironmentRequest.
 * Use `create(UpdateEnvironmentRequestSchema)` to create a new message.
 */
export const UpdateEnvironmentRequestSchema: GenMessage<UpdateEnvironmentRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 30);

/**
 * @generated from message gitpod.v1.UpdateEnvironmentRequest.Content
 */
export type UpdateEnvironmentRequest_Content = Message<"gitpod.v1.UpdateEnvironmentRequest.Content"> & {
  /**
   * session should be changed to trigger a content reinitialization
   *
   * @generated from field: optional string session = 1;
   */
  session?: string;

  /**
   * initializer configures how the environment is to be initialized
   *
   * @generated from field: optional gitpod.v1.EnvironmentInitializer initializer = 2;
   */
  initializer?: EnvironmentInitializer;

  /**
   * The Git username
   *
   * @generated from field: optional string git_username = 3;
   */
  gitUsername?: string;

  /**
   * The Git email address
   *
   * @generated from field: optional string git_email = 4;
   */
  gitEmail?: string;
};

/**
 * Describes the message gitpod.v1.UpdateEnvironmentRequest.Content.
 * Use `create(UpdateEnvironmentRequest_ContentSchema)` to create a new message.
 */
export const UpdateEnvironmentRequest_ContentSchema: GenMessage<UpdateEnvironmentRequest_Content> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 30, 0);

/**
 * @generated from message gitpod.v1.UpdateEnvironmentRequest.SSHPublicKey
 */
export type UpdateEnvironmentRequest_SSHPublicKey = Message<"gitpod.v1.UpdateEnvironmentRequest.SSHPublicKey"> & {
  /**
   * id is the unique identifier of the public key
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * value is the actual public key in the public key file format
   * if not provided, the public key will be removed
   *
   * @generated from field: optional string value = 2;
   */
  value?: string;
};

/**
 * Describes the message gitpod.v1.UpdateEnvironmentRequest.SSHPublicKey.
 * Use `create(UpdateEnvironmentRequest_SSHPublicKeySchema)` to create a new message.
 */
export const UpdateEnvironmentRequest_SSHPublicKeySchema: GenMessage<UpdateEnvironmentRequest_SSHPublicKey> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 30, 1);

/**
 * @generated from message gitpod.v1.UpdateEnvironmentRequest.DevContainer
 */
export type UpdateEnvironmentRequest_DevContainer = Message<"gitpod.v1.UpdateEnvironmentRequest.DevContainer"> & {
  /**
   * session should be changed to trigger a devcontainer rebuild
   *
   * @generated from field: optional string session = 1;
   */
  session?: string;

  /**
   * devcontainer_file_path is the path to the devcontainer file relative to the repo root
   *
   * @generated from field: optional string devcontainer_file_path = 2;
   */
  devcontainerFilePath?: string;
};

/**
 * Describes the message gitpod.v1.UpdateEnvironmentRequest.DevContainer.
 * Use `create(UpdateEnvironmentRequest_DevContainerSchema)` to create a new message.
 */
export const UpdateEnvironmentRequest_DevContainerSchema: GenMessage<UpdateEnvironmentRequest_DevContainer> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 30, 2);

/**
 * @generated from message gitpod.v1.UpdateEnvironmentRequest.Timeout
 */
export type UpdateEnvironmentRequest_Timeout = Message<"gitpod.v1.UpdateEnvironmentRequest.Timeout"> & {
  /**
   * inacitivity is the maximum time of disconnection before the environment is
   * stopped or paused. Minimum duration is 30 minutes. Set to 0 to disable.
   *
   * @generated from field: optional google.protobuf.Duration disconnected = 1;
   */
  disconnected?: Duration;
};

/**
 * Describes the message gitpod.v1.UpdateEnvironmentRequest.Timeout.
 * Use `create(UpdateEnvironmentRequest_TimeoutSchema)` to create a new message.
 */
export const UpdateEnvironmentRequest_TimeoutSchema: GenMessage<UpdateEnvironmentRequest_Timeout> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 30, 3);

/**
 * @generated from message gitpod.v1.UpdateEnvironmentRequest.AutomationsFile
 */
export type UpdateEnvironmentRequest_AutomationsFile = Message<"gitpod.v1.UpdateEnvironmentRequest.AutomationsFile"> & {
  /**
   * @generated from field: optional string session = 1;
   */
  session?: string;

  /**
   * automations_file_path is the path to the automations file that is applied in the environment,
   * relative to the repo root.
   *
   * @generated from field: optional string automations_file_path = 2;
   */
  automationsFilePath?: string;
};

/**
 * Describes the message gitpod.v1.UpdateEnvironmentRequest.AutomationsFile.
 * Use `create(UpdateEnvironmentRequest_AutomationsFileSchema)` to create a new message.
 */
export const UpdateEnvironmentRequest_AutomationsFileSchema: GenMessage<UpdateEnvironmentRequest_AutomationsFile> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 30, 4);

/**
 * @generated from message gitpod.v1.UpdateEnvironmentRequest.Metadata
 */
export type UpdateEnvironmentRequest_Metadata = Message<"gitpod.v1.UpdateEnvironmentRequest.Metadata"> & {
  /**
   * name is the user-defined display name of the environment
   *
   * @generated from field: optional string name = 1;
   */
  name?: string;

  /**
   * lockdown_at sets or clears the lockdown time for this environment.
   * Only org admins can set this field. When set to a future time, the
   * environment will become blocked at that time. When cleared (set to
   * epoch zero), the lockdown is removed. Setting to a past time is rejected.
   *
   * @generated from field: optional google.protobuf.Timestamp lockdown_at = 2;
   */
  lockdownAt?: Timestamp;
};

/**
 * Describes the message gitpod.v1.UpdateEnvironmentRequest.Metadata.
 * Use `create(UpdateEnvironmentRequest_MetadataSchema)` to create a new message.
 */
export const UpdateEnvironmentRequest_MetadataSchema: GenMessage<UpdateEnvironmentRequest_Metadata> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 30, 5);

/**
 * @generated from message gitpod.v1.UpdateEnvironmentRequest.Spec
 */
export type UpdateEnvironmentRequest_Spec = Message<"gitpod.v1.UpdateEnvironmentRequest.Spec"> & {
  /**
   * @generated from field: optional gitpod.v1.UpdateEnvironmentRequest.Content content = 2;
   */
  content?: UpdateEnvironmentRequest_Content;

  /**
   * ssh_public_keys are the public keys to update
   * empty array means nothing to update
   *
   * @generated from field: repeated gitpod.v1.UpdateEnvironmentRequest.SSHPublicKey ssh_public_keys = 3;
   */
  sshPublicKeys: UpdateEnvironmentRequest_SSHPublicKey[];

  /**
   * @generated from field: optional gitpod.v1.UpdateEnvironmentRequest.DevContainer devcontainer = 4;
   */
  devcontainer?: UpdateEnvironmentRequest_DevContainer;

  /**
   * ports controls port sharing
   *
   * @generated from field: repeated gitpod.v1.EnvironmentSpec.EnvironmentPort ports = 5;
   */
  ports: EnvironmentSpec_EnvironmentPort[];

  /**
   * Timeout configures the environment timeout
   *
   * @generated from field: optional gitpod.v1.UpdateEnvironmentRequest.Timeout timeout = 6;
   */
  timeout?: UpdateEnvironmentRequest_Timeout;

  /**
   * automations_file is the automations file spec of the environment
   *
   * @generated from field: optional gitpod.v1.UpdateEnvironmentRequest.AutomationsFile automations_file = 7;
   */
  automationsFile?: UpdateEnvironmentRequest_AutomationsFile;

  /**
   * kernel_controls_config configures kernel-level controls for this environment
   *
   * @generated from field: optional gitpod.v1.KernelControlsConfig kernel_controls_config = 8;
   */
  kernelControlsConfig?: KernelControlsConfig;
};

/**
 * Describes the message gitpod.v1.UpdateEnvironmentRequest.Spec.
 * Use `create(UpdateEnvironmentRequest_SpecSchema)` to create a new message.
 */
export const UpdateEnvironmentRequest_SpecSchema: GenMessage<UpdateEnvironmentRequest_Spec> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 30, 6);

/**
 * @generated from message gitpod.v1.UpdateEnvironmentResponse
 */
export type UpdateEnvironmentResponse = Message<"gitpod.v1.UpdateEnvironmentResponse"> & {
};

/**
 * Describes the message gitpod.v1.UpdateEnvironmentResponse.
 * Use `create(UpdateEnvironmentResponseSchema)` to create a new message.
 */
export const UpdateEnvironmentResponseSchema: GenMessage<UpdateEnvironmentResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 31);

/**
 * @generated from message gitpod.v1.DeleteEnvironmentRequest
 */
export type DeleteEnvironmentRequest = Message<"gitpod.v1.DeleteEnvironmentRequest"> & {
  /**
   * environment_id specifies the environment that is going to delete.
   *
   * +required
   *
   * @generated from field: string environment_id = 1;
   */
  environmentId: string;

  /**
   * force indicates whether the environment should be deleted forcefully
   * When force deleting an Environment, the Environment is removed immediately and
   * environment lifecycle is not respected.
   * Force deleting can result in data loss on the environment.
   *
   * @generated from field: bool force = 2;
   */
  force: boolean;
};

/**
 * Describes the message gitpod.v1.DeleteEnvironmentRequest.
 * Use `create(DeleteEnvironmentRequestSchema)` to create a new message.
 */
export const DeleteEnvironmentRequestSchema: GenMessage<DeleteEnvironmentRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 32);

/**
 * @generated from message gitpod.v1.DeleteEnvironmentResponse
 */
export type DeleteEnvironmentResponse = Message<"gitpod.v1.DeleteEnvironmentResponse"> & {
};

/**
 * Describes the message gitpod.v1.DeleteEnvironmentResponse.
 * Use `create(DeleteEnvironmentResponseSchema)` to create a new message.
 */
export const DeleteEnvironmentResponseSchema: GenMessage<DeleteEnvironmentResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 33);

/**
 * @generated from message gitpod.v1.CreateEnvironmentLogsTokenRequest
 */
export type CreateEnvironmentLogsTokenRequest = Message<"gitpod.v1.CreateEnvironmentLogsTokenRequest"> & {
  /**
   * environment_id specifies the environment for which the logs token should be created.
   *
   * +required
   *
   * @generated from field: string environment_id = 1;
   */
  environmentId: string;
};

/**
 * Describes the message gitpod.v1.CreateEnvironmentLogsTokenRequest.
 * Use `create(CreateEnvironmentLogsTokenRequestSchema)` to create a new message.
 */
export const CreateEnvironmentLogsTokenRequestSchema: GenMessage<CreateEnvironmentLogsTokenRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 34);

/**
 * @generated from message gitpod.v1.CreateEnvironmentLogsTokenResponse
 */
export type CreateEnvironmentLogsTokenResponse = Message<"gitpod.v1.CreateEnvironmentLogsTokenResponse"> & {
  /**
   * access_token is the token that can be used to access the logs of the environment
   *
   * @generated from field: string access_token = 1;
   */
  accessToken: string;
};

/**
 * Describes the message gitpod.v1.CreateEnvironmentLogsTokenResponse.
 * Use `create(CreateEnvironmentLogsTokenResponseSchema)` to create a new message.
 */
export const CreateEnvironmentLogsTokenResponseSchema: GenMessage<CreateEnvironmentLogsTokenResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 35);

/**
 * @generated from message gitpod.v1.CreateEnvironmentAccessTokenRequest
 */
export type CreateEnvironmentAccessTokenRequest = Message<"gitpod.v1.CreateEnvironmentAccessTokenRequest"> & {
  /**
   * environment_id specifies the environment for which the access token should be created.
   *
   * @generated from field: string environment_id = 1;
   */
  environmentId: string;
};

/**
 * Describes the message gitpod.v1.CreateEnvironmentAccessTokenRequest.
 * Use `create(CreateEnvironmentAccessTokenRequestSchema)` to create a new message.
 */
export const CreateEnvironmentAccessTokenRequestSchema: GenMessage<CreateEnvironmentAccessTokenRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 36);

/**
 * @generated from message gitpod.v1.CreateEnvironmentAccessTokenResponse
 */
export type CreateEnvironmentAccessTokenResponse = Message<"gitpod.v1.CreateEnvironmentAccessTokenResponse"> & {
  /**
   * access_token is the token that can be used for environment authentication
   *
   * @generated from field: string access_token = 1;
   */
  accessToken: string;
};

/**
 * Describes the message gitpod.v1.CreateEnvironmentAccessTokenResponse.
 * Use `create(CreateEnvironmentAccessTokenResponseSchema)` to create a new message.
 */
export const CreateEnvironmentAccessTokenResponseSchema: GenMessage<CreateEnvironmentAccessTokenResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 37);

/**
 * @generated from message gitpod.v1.CreatePortAccessTokenRequest
 */
export type CreatePortAccessTokenRequest = Message<"gitpod.v1.CreatePortAccessTokenRequest"> & {
  /**
   * environment_id specifies the environment for which the port access token should be created.
   *
   * +required
   *
   * @generated from field: string environment_id = 1;
   */
  environmentId: string;

  /**
   * port specifies the port number for which the access token should be created.
   *
   * +required
   *
   * @generated from field: int32 port = 2;
   */
  port: number;
};

/**
 * Describes the message gitpod.v1.CreatePortAccessTokenRequest.
 * Use `create(CreatePortAccessTokenRequestSchema)` to create a new message.
 */
export const CreatePortAccessTokenRequestSchema: GenMessage<CreatePortAccessTokenRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 38);

/**
 * @generated from message gitpod.v1.CreatePortAccessTokenResponse
 */
export type CreatePortAccessTokenResponse = Message<"gitpod.v1.CreatePortAccessTokenResponse"> & {
  /**
   * access_token is the token that can be used to access the port.
   *
   * @generated from field: string access_token = 1;
   */
  accessToken: string;
};

/**
 * Describes the message gitpod.v1.CreatePortAccessTokenResponse.
 * Use `create(CreatePortAccessTokenResponseSchema)` to create a new message.
 */
export const CreatePortAccessTokenResponseSchema: GenMessage<CreatePortAccessTokenResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 39);

/**
 * @generated from message gitpod.v1.AllowPortAccessRequest
 */
export type AllowPortAccessRequest = Message<"gitpod.v1.AllowPortAccessRequest"> & {
  /**
   * environment_id specifies the environment to check access for.
   *
   * +required
   *
   * @generated from field: string environment_id = 1;
   */
  environmentId: string;

  /**
   * port specifies the port number to check access for.
   *
   * +required
   *
   * @generated from field: int32 port = 2;
   */
  port: number;
};

/**
 * Describes the message gitpod.v1.AllowPortAccessRequest.
 * Use `create(AllowPortAccessRequestSchema)` to create a new message.
 */
export const AllowPortAccessRequestSchema: GenMessage<AllowPortAccessRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 40);

/**
 * @generated from message gitpod.v1.AllowPortAccessResponse
 */
export type AllowPortAccessResponse = Message<"gitpod.v1.AllowPortAccessResponse"> & {
  /**
   * allowed indicates whether the caller is permitted to access the port.
   *
   * @generated from field: bool allowed = 1;
   */
  allowed: boolean;
};

/**
 * Describes the message gitpod.v1.AllowPortAccessResponse.
 * Use `create(AllowPortAccessResponseSchema)` to create a new message.
 */
export const AllowPortAccessResponseSchema: GenMessage<AllowPortAccessResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_environment, 41);

/**
 * KernelControlsAction defines how a kernel-level policy violation is handled.
 *
 * @generated from enum gitpod.v1.KernelControlsAction
 */
export enum KernelControlsAction {
  /**
   * KERNEL_CONTROLS_ACTION_UNSPECIFIED defaults to BLOCK.
   *
   * @generated from enum value: KERNEL_CONTROLS_ACTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * KERNEL_CONTROLS_ACTION_BLOCK denies the operation.
   *
   * @generated from enum value: KERNEL_CONTROLS_ACTION_BLOCK = 1;
   */
  BLOCK = 1,

  /**
   * KERNEL_CONTROLS_ACTION_AUDIT logs the operation without blocking it.
   *
   * @generated from enum value: KERNEL_CONTROLS_ACTION_AUDIT = 2;
   */
  AUDIT = 2,
}

/**
 * Describes the enum gitpod.v1.KernelControlsAction.
 */
export const KernelControlsActionSchema: GenEnum<KernelControlsAction> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_environment, 0);

/**
 * BPFDebugLevel controls the verbosity of BPF trace_pipe output (bpf_printk).
 * Applies to all BPF-based agents (veto exec, future agents).
 *
 * @generated from enum gitpod.v1.BPFDebugLevel
 */
export enum BPFDebugLevel {
  /**
   * BPF_DEBUG_LEVEL_UNSPECIFIED disables all bpf_printk output (default).
   *
   * @generated from enum value: BPF_DEBUG_LEVEL_UNSPECIFIED = 0;
   */
  BPF_DEBUG_LEVEL_UNSPECIFIED = 0,

  /**
   * BPF_DEBUG_LEVEL_INFO enables decision-level prints (e.g., veto allow/block).
   *
   * @generated from enum value: BPF_DEBUG_LEVEL_INFO = 1;
   */
  BPF_DEBUG_LEVEL_INFO = 1,

  /**
   * BPF_DEBUG_LEVEL_VERBOSE enables all debug prints including data fillers.
   *
   * @generated from enum value: BPF_DEBUG_LEVEL_VERBOSE = 2;
   */
  BPF_DEBUG_LEVEL_VERBOSE = 2,
}

/**
 * Describes the enum gitpod.v1.BPFDebugLevel.
 */
export const BPFDebugLevelSchema: GenEnum<BPFDebugLevel> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_environment, 1);

/**
 * Admission level describes who can access an environment instance and its ports.
 *
 * @generated from enum gitpod.v1.AdmissionLevel
 */
export enum AdmissionLevel {
  /**
   * @generated from enum value: ADMISSION_LEVEL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * ADMISSION_LEVEL_OWNER_ONLY means the environment can only be accessed by the creator.
   * Deprecated: Use ADMISSION_LEVEL_CREATOR_ONLY instead.
   *
   * @generated from enum value: ADMISSION_LEVEL_OWNER_ONLY = 1 [deprecated = true];
   * @deprecated
   */
  OWNER_ONLY = 1,

  /**
   * ADMISSION_LEVEL_EVERYONE means the environment (including ports) can be
   * accessed by everyone.
   *
   * @generated from enum value: ADMISSION_LEVEL_EVERYONE = 2;
   */
  EVERYONE = 2,

  /**
   * ADMISSION_LEVEL_ORGANIZATION means the environment (including ports) can be
   * accessed by all members of the organization.
   *
   * @generated from enum value: ADMISSION_LEVEL_ORGANIZATION = 3;
   */
  ORGANIZATION = 3,

  /**
   * ADMISSION_LEVEL_CREATOR_ONLY means the environment (including ports) can only
   * be accessed by the user who created the environment.
   *
   * @generated from enum value: ADMISSION_LEVEL_CREATOR_ONLY = 4;
   */
  CREATOR_ONLY = 4,
}

/**
 * Describes the enum gitpod.v1.AdmissionLevel.
 */
export const AdmissionLevelSchema: GenEnum<AdmissionLevel> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_environment, 2);

/**
 * @generated from enum gitpod.v1.EnvironmentPhase
 */
export enum EnvironmentPhase {
  /**
   * Unknown indicates an issue within the environment manager in that it cannot
   * determine the actual phase of an environment. This phase is usually
   * accompanied by an error.
   *
   * @generated from enum value: ENVIRONMENT_PHASE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Creating means that the environment is first created. We organise the SCM credentials,
   * parse context URL if need be, and allocate the unit of compute.
   *
   * @generated from enum value: ENVIRONMENT_PHASE_CREATING = 10;
   */
  CREATING = 10,

  /**
   * Starting means that the environment is currently being started. This includes
   * starting the unit of compute (machine), resolving secrets, setting up the Git config,
   * initiaing the content, and starting the devcontainer.
   *
   * @generated from enum value: ENVIRONMENT_PHASE_STARTING = 20;
   */
  STARTING = 20,

  /**
   * Running means the environment is able to actively perform work, either by
   * serving a user through Theia, or as a headless environment.
   *
   * @generated from enum value: ENVIRONMENT_PHASE_RUNNING = 40;
   */
  RUNNING = 40,

  /**
   * Updating means the environment is currently being updated. This includes
   * content updates, devcontainer updates, secret updates and SSH public key updates.
   * This phase implies that the environment is running.
   *
   * @generated from enum value: ENVIRONMENT_PHASE_UPDATING = 45;
   */
  UPDATING = 45,

  /**
   * Stopping means that the environment is currently shutting down. It could go
   * to stopped every moment.
   *
   * @generated from enum value: ENVIRONMENT_PHASE_STOPPING = 50;
   */
  STOPPING = 50,

  /**
   * Stopped means the environment ended regularly because it was shut down.
   *
   * @generated from enum value: ENVIRONMENT_PHASE_STOPPED = 60;
   */
  STOPPED = 60,

  /**
   * Deleting means the environment is currently being deleted. It could go to
   * deleted any moment. This phase implies that the environment is stopped.
   *
   * @generated from enum value: ENVIRONMENT_PHASE_DELETING = 70;
   */
  DELETING = 70,

  /**
   * Deleted means the environment was deleted and cannot be started again.
   * This phase implies that the environment is stopped.
   *
   * @generated from enum value: ENVIRONMENT_PHASE_DELETED = 80;
   */
  DELETED = 80,
}

/**
 * Describes the enum gitpod.v1.EnvironmentPhase.
 */
export const EnvironmentPhaseSchema: GenEnum<EnvironmentPhase> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_environment, 3);

/**
 * EnvironmentRole represents the role of an environment
 *
 * @generated from enum gitpod.v1.EnvironmentRole
 */
export enum EnvironmentRole {
  /**
   * @generated from enum value: ENVIRONMENT_ROLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Default role for environments
   *
   * @generated from enum value: ENVIRONMENT_ROLE_DEFAULT = 1;
   */
  DEFAULT = 1,

  /**
   * Prebuild role for environments that are prebuilds
   *
   * @generated from enum value: ENVIRONMENT_ROLE_PREBUILD = 2;
   */
  PREBUILD = 2,

  /**
   * Workflow role for environments that are part of a workflow
   *
   * @generated from enum value: ENVIRONMENT_ROLE_WORKFLOW = 3;
   */
  WORKFLOW = 3,
}

/**
 * Describes the enum gitpod.v1.EnvironmentRole.
 */
export const EnvironmentRoleSchema: GenEnum<EnvironmentRole> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_environment, 4);

/**
 * @generated from service gitpod.v1.EnvironmentService
 */
export const EnvironmentService: GenService<{
  /**
   * Gets details about a specific environment including its status, configuration, and context URL.
   *
   * Use this method to:
   * - Check if an environment is ready to use
   * - Get connection details for IDE and exposed ports
   * - Monitor environment health and resource usage
   * - Debug environment setup issues
   *
   * ### Examples
   *
   * - Get environment details:
   *
   *   Retrieves detailed information about a specific environment using its unique identifier.
   *
   *   ```yaml
   *   environmentId: "07e03a28-65a5-4d98-b532-8ea67b188048"
   *   ```
   *
   * @generated from rpc gitpod.v1.EnvironmentService.GetEnvironment
   */
  getEnvironment: {
    methodKind: "unary";
    input: typeof GetEnvironmentRequestSchema;
    output: typeof GetEnvironmentResponseSchema;
  },
  /**
   * Lists all environments matching the specified criteria.
   *
   * Use this method to find and monitor environments across your organization.
   * Results are ordered by creation time with newest environments first.
   *
   * ### Examples
   *
   * - List running environments for a project:
   *
   *   Retrieves all running environments for a specific project with pagination.
   *
   *   ```yaml
   *   filter:
   *     statusPhases: ["ENVIRONMENT_PHASE_RUNNING"]
   *     projectIds: ["b0e12f6c-4c67-429d-a4a6-d9838b5da047"]
   *   pagination:
   *     pageSize: 10
   *   ```
   *
   * - List all environments for a specific runner:
   *
   *   Filters environments by runner ID and creator ID.
   *
   *   ```yaml
   *   filter:
   *     runnerIds: ["e6aa9c54-89d3-42c1-ac31-bd8d8f1concentrate"]
   *     creatorIds: ["f53d2330-3795-4c5d-a1f3-453121af9c60"]
   *   ```
   *
   * - List stopped and deleted environments:
   *
   *   Retrieves all environments in stopped or deleted state.
   *
   *   ```yaml
   *   filter:
   *     statusPhases: ["ENVIRONMENT_PHASE_STOPPED", "ENVIRONMENT_PHASE_DELETED"]
   *   ```
   *
   * @generated from rpc gitpod.v1.EnvironmentService.ListEnvironments
   */
  listEnvironments: {
    methodKind: "unary";
    input: typeof ListEnvironmentsRequestSchema;
    output: typeof ListEnvironmentsResponseSchema;
  },
  /**
   * Lists available environment classes with their specifications and resource limits.
   *
   * Use this method to understand what types of environments you can create and their
   * capabilities. Environment classes define the compute resources and features available
   * to your environments.
   *
   * ### Examples
   *
   * - List all available classes:
   *
   *   Retrieves a list of all environment classes with their specifications.
   *
   *   ```yaml
   *   {}
   *   ```
   * buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE
   *
   * @generated from rpc gitpod.v1.EnvironmentService.ListEnvironmentClasses
   */
  listEnvironmentClasses: {
    methodKind: "unary";
    input: typeof ListEnvironmentClassesRequestSchema;
    output: typeof ListEnvironmentClassesResponseSchema;
  },
  /**
   * Creates a development environment from a context URL (e.g. Git repository) and starts it.
   *
   * The `class` field must be a valid environment class ID. You can find a list of
   * available environment classes with the `ListEnvironmentClasses` method.
   *
   * ### Examples
   *
   * - Create from context URL:
   *
   *   Creates an environment from a Git repository URL with default settings.
   *
   *   ```yaml
   *   spec:
   *     machine:
   *       class: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *     content:
   *       initializer:
   *         specs:
   *           - contextUrl:
   *               url: "https://github.com/gitpod-io/gitpod"
   *   ```
   *
   * - Create from Git repository:
   *
   *   Creates an environment from a Git repository with specific branch targeting.
   *
   *   ```yaml
   *   spec:
   *     machine:
   *       class: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *     content:
   *       initializer:
   *         specs:
   *           - git:
   *               remoteUri: "https://github.com/gitpod-io/gitpod"
   *               cloneTarget: "main"
   *               targetMode: "CLONE_TARGET_MODE_REMOTE_BRANCH"
   *   ```
   *
   * - Create with custom timeout and ports:
   *
   *   Creates an environment with custom inactivity timeout and exposed port configuration.
   *
   *   ```yaml
   *   spec:
   *     machine:
   *       class: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *     content:
   *       initializer:
   *         specs:
   *           - contextUrl:
   *               url: "https://github.com/gitpod-io/gitpod"
   *     timeout:
   *       disconnected: "7200s"  # 2 hours in seconds
   *     ports:
   *       - port: 3000
   *         admission: "ADMISSION_LEVEL_EVERYONE"
   *         name: "Web App"
   *   ```
   *
   * @generated from rpc gitpod.v1.EnvironmentService.CreateEnvironment
   */
  createEnvironment: {
    methodKind: "unary";
    input: typeof CreateEnvironmentRequestSchema;
    output: typeof CreateEnvironmentResponseSchema;
  },
  /**
   * Creates an environment from an existing project configuration and starts it.
   *
   * This method uses project settings as defaults but allows overriding specific
   * configurations. Project settings take precedence over default configurations,
   * while custom specifications in the request override project settings.
   *
   * ### Examples
   *
   * - Create with project defaults:
   *
   *   Creates an environment using all default settings from the project configuration.
   *
   *   ```yaml
   *   projectId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   ```
   *
   * - Create with custom compute resources:
   *
   *   Creates an environment from project with custom machine class and timeout settings.
   *
   *   ```yaml
   *   projectId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   spec:
   *     machine:
   *       class: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *     timeout:
   *       disconnected: "14400s"  # 4 hours in seconds
   *   ```
   *
   * @generated from rpc gitpod.v1.EnvironmentService.CreateEnvironmentFromProject
   */
  createEnvironmentFromProject: {
    methodKind: "unary";
    input: typeof CreateEnvironmentFromProjectRequestSchema;
    output: typeof CreateEnvironmentFromProjectResponseSchema;
  },
  /**
   * Starts a stopped environment.
   *
   * Use this method to resume work on a previously stopped environment. The environment
   * retains its configuration and workspace content from when it was stopped.
   *
   * ### Examples
   *
   * - Start an environment:
   *
   *   Resumes a previously stopped environment with its existing configuration.
   *
   *   ```yaml
   *   environmentId: "07e03a28-65a5-4d98-b532-8ea67b188048"
   *   ```
   *
   * @generated from rpc gitpod.v1.EnvironmentService.StartEnvironment
   */
  startEnvironment: {
    methodKind: "unary";
    input: typeof StartEnvironmentRequestSchema;
    output: typeof StartEnvironmentResponseSchema;
  },
  /**
   * Stops a running environment.
   *
   * Use this method to pause work while preserving the environment's state.
   * The environment can be resumed later using StartEnvironment.
   *
   * ### Examples
   *
   * - Stop an environment:
   *
   *   Gracefully stops a running environment while preserving its state.
   *
   *   ```yaml
   *   environmentId: "07e03a28-65a5-4d98-b532-8ea67b188048"
   *   ```
   *
   * @generated from rpc gitpod.v1.EnvironmentService.StopEnvironment
   */
  stopEnvironment: {
    methodKind: "unary";
    input: typeof StopEnvironmentRequestSchema;
    output: typeof StopEnvironmentResponseSchema;
  },
  /**
   * Updates an environment's configuration while it is running.
   *
   * Updates are limited to:
   * - Git credentials (username, email)
   * - SSH public keys
   * - Content initialization
   * - Port configurations
   * - Automation files
   * - Environment timeouts
   *
   * ### Examples
   *
   * - Update Git credentials:
   *
   *   Updates the Git configuration for the environment.
   *
   *   ```yaml
   *   environmentId: "07e03a28-65a5-4d98-b532-8ea67b188048"
   *   spec:
   *     content:
   *       gitUsername: "example-user"
   *       gitEmail: "user@example.com"
   *   ```
   *
   * - Add SSH public key:
   *
   *   Adds a new SSH public key for authentication.
   *
   *   ```yaml
   *   environmentId: "07e03a28-65a5-4d98-b532-8ea67b188048"
   *   spec:
   *     sshPublicKeys:
   *       - id: "0194b7c1-c954-718d-91a4-9a742aa5fc11"
   *         value: "ssh-ed25519 AAAAC3NzaC1lZDI1NTE5AAAAI..."
   *   ```
   *
   * - Update content session:
   *
   *   Updates the content session identifier for the environment.
   *
   *   ```yaml
   *   environmentId: "07e03a28-65a5-4d98-b532-8ea67b188048"
   *   spec:
   *     content:
   *       session: "0194b7c1-c954-718d-91a4-9a742aa5fc11"
   *   ```
   *
   * Note: Machine class changes require stopping the environment and creating a new one.
   *
   * @generated from rpc gitpod.v1.EnvironmentService.UpdateEnvironment
   */
  updateEnvironment: {
    methodKind: "unary";
    input: typeof UpdateEnvironmentRequestSchema;
    output: typeof UpdateEnvironmentResponseSchema;
  },
  /**
   * Permanently deletes an environment.
   *
   * Running environments are automatically stopped before deletion. If force
   * is true, the environment is deleted immediately without graceful shutdown.
   *
   * ### Examples
   *
   * - Delete with graceful shutdown:
   *
   *   Deletes an environment after gracefully stopping it.
   *
   *   ```yaml
   *   environmentId: "07e03a28-65a5-4d98-b532-8ea67b188048"
   *   force: false
   *   ```
   *
   * - Force delete:
   *
   *   Immediately deletes an environment without waiting for graceful shutdown.
   *
   *   ```yaml
   *   environmentId: "07e03a28-65a5-4d98-b532-8ea67b188048"
   *   force: true
   *   ```
   *
   * @generated from rpc gitpod.v1.EnvironmentService.DeleteEnvironment
   */
  deleteEnvironment: {
    methodKind: "unary";
    input: typeof DeleteEnvironmentRequestSchema;
    output: typeof DeleteEnvironmentResponseSchema;
  },
  /**
   * Creates an access token for retrieving environment logs.
   *
   * Generated tokens are valid for one hour and provide read-only access
   * to the environment's logs.
   *
   * ### Examples
   *
   * - Generate logs token:
   *
   *   Creates a temporary access token for retrieving environment logs.
   *
   *   ```yaml
   *   environmentId: "07e03a28-65a5-4d98-b532-8ea67b188048"
   *   ```
   *
   * @generated from rpc gitpod.v1.EnvironmentService.CreateEnvironmentLogsToken
   */
  createEnvironmentLogsToken: {
    methodKind: "unary";
    input: typeof CreateEnvironmentLogsTokenRequestSchema;
    output: typeof CreateEnvironmentLogsTokenResponseSchema;
  },
  /**
   * Creates an access token for the environment.
   *
   * Generated tokens are valid for one hour and provide environment-specific access permissions.
   * The token is scoped to a specific environment.
   *
   * ### Examples
   *
   * - Generate environment token:
   *
   *   Creates a temporary access token for accessing an environment.
   *
   *   ```yaml
   *   environmentId: "07e03a28-65a5-4d98-b532-8ea67b188048"
   *   ```
   *
   * @generated from rpc gitpod.v1.EnvironmentService.CreateEnvironmentAccessToken
   */
  createEnvironmentAccessToken: {
    methodKind: "unary";
    input: typeof CreateEnvironmentAccessTokenRequestSchema;
    output: typeof CreateEnvironmentAccessTokenResponseSchema;
  },
  /**
   * Creates an access token for a specific port on an environment.
   *
   * The token grants access to the specified port based on the port's admission level.
   * Tokens are short-lived (~1 hour) with refresh tokens for long-running connections.
   *
   * ### Examples
   *
   * - Generate port access token:
   *
   *   Creates a token for accessing port 8080 on an environment.
   *
   *   ```yaml
   *   environmentId: "07e03a28-65a5-4d98-b532-8ea67b188048"
   *   port: 8080
   *   ```
   *
   * @generated from rpc gitpod.v1.EnvironmentService.CreatePortAccessToken
   */
  createPortAccessToken: {
    methodKind: "unary";
    input: typeof CreatePortAccessTokenRequestSchema;
    output: typeof CreatePortAccessTokenResponseSchema;
  },
  /**
   * Deprecated: Use local validation with the environment state cache instead.
   *
   * Checks if the authenticated caller can access a specific port on an environment.
   * This is called by the Runner Proxy to validate access tokens against current state.
   * The caller's identity is extracted from the JWT in the request context.
   *
   * ### Examples
   *
   * - Check port access:
   *
   *   Verifies if the caller can access port 8080 on an environment.
   *
   *   ```yaml
   *   environmentId: "07e03a28-65a5-4d98-b532-8ea67b188048"
   *   port: 8080
   *   ```
   *
   * @generated from rpc gitpod.v1.EnvironmentService.AllowPortAccess
   * @deprecated
   */
  allowPortAccess: {
    methodKind: "unary";
    input: typeof AllowPortAccessRequestSchema;
    output: typeof AllowPortAccessResponseSchema;
  },
  /**
   * Records environment activity to prevent automatic shutdown.
   *
   * Activity signals should be sent every 5 minutes while the environment
   * is actively being used. The source must be between 3-80 characters.
   *
   * ### Examples
   *
   * - Signal VS Code activity:
   *
   *   Records VS Code editor activity to prevent environment shutdown.
   *
   *   ```yaml
   *   environmentId: "07e03a28-65a5-4d98-b532-8ea67b188048"
   *   activitySignal:
   *     source: "VS Code"
   *     timestamp: "2025-02-12T14:30:00Z"
   *   ```
   *
   * @generated from rpc gitpod.v1.EnvironmentService.MarkEnvironmentActive
   */
  markEnvironmentActive: {
    methodKind: "unary";
    input: typeof MarkEnvironmentActiveRequestSchema;
    output: typeof MarkEnvironmentActiveResponseSchema;
  },
  /**
   * Unarchives an environment.
   *
   * ### Examples
   *
   * - Unarchive an environment:
   *
   *   ```yaml
   *   environmentId: "07e03a28-65a5-4d98-b532-8ea67b188048"
   *   ```
   *
   * @generated from rpc gitpod.v1.EnvironmentService.UnarchiveEnvironment
   */
  unarchiveEnvironment: {
    methodKind: "unary";
    input: typeof UnarchiveEnvironmentRequestSchema;
    output: typeof UnarchiveEnvironmentResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_gitpod_v1_environment, 0);

